<template>
  <div>
    <Overlay :overlay="overlay" />
    <Snackbar :SnackBarComponent="SnackBarComponent" v-if="renderComp" />
    <AddServiceDetails
      :AddServiceDetailsDialog="AddServiceDetailsDialog"
      :PrevData="PrevData"
      :StoreObj="StoreObj"
      @clicked="AddServiceDetailsDialogEmit"
    />
    <EditTerritoryDialog
      :EditTerritoryDialog="EditTerritoryDialog"
      :ActionObj="ActionObj"
      @clicked="EditTerritoriesEmit"
    />
    <ListPincodesHistoryDialog
      :ListPincodesHistoryDialog="ListPincodesHistoryDialog"
      :ActionObj="ActionObj"
      @clicked="ListPincodesHistoryDialogEmit"
    />
    <DeleteTerritoryClassification
      :DeleteTerrClassDialog="deleteTerrClassDialog"
      :TerritoryObj="territoryObj"
      @clicked="DeleteTerrClassDialogEmit"
    />
    <WebHookCard v-if="hideWebHookViewButton" @clicked="webHookCardEmit" />
    <v-card
      v-else-if="!headless"
      class="elevation-0 org-settings-page page-layout--compact-fields"
    >
      <PageContentHeader
        subtitle="Configure organization-wide defaults for tickets, attendance, and integrations."
        :stack-filters-below-title="true"
      >
        <template #title>
          Settings
          <span class="PrimaryFontColorSmall">/ Organization Settings</span>
        </template>
        <template #search>
          <SwSearchField
            :model-value="categorySearch"
            placeholder="Search settings"
            clearable
            @update:model-value="categorySearch = $event"
          />
        </template>
        <template #actions>
          <SwHeaderIconBtn
            tooltip="Copy customer form URL"
            icon="mdi-content-copy"
            @click="copyFormUrlCustomer()"
          />
        </template>
      </PageContentHeader>

      <div class="org-settings-page__hub">
        <div class="org-settings-page__hub-card">
          <OrganizationSettingsCategoryNav
            v-model:search="categorySearch"
            :categories="visibleCategories"
            :active-id="activeCategory"
            @select="openCategory"
          />
        </div>
      </div>
    </v-card>

    <OrganizationSettingsDetailDialog
        v-if="activeCategoryMeta"
        :open="!!activeCategory"
        :title="activeCategoryMeta.title"
        :icon="activeCategoryMeta.icon"
        :subtitle="activeCategoryMeta.description"
        :section-title="activeCategoryMeta.sectionTitle"
        :section-icon="activeCategoryMeta.sectionIcon"
        :wrap-in-section-card="activeCategoryMeta.wrapInSectionCard !== false"
        :max-width="activeCategoryMeta.dialogWidth || 520"
        @close="closeCategory"
      >
        <section
          v-if="activeCategory === 'org-logo'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-page__logo-section">
                <OrgSettingsDialogField label="Organization Logo">
                  <div
                    class="org-settings-page__logo-card"
                    @click="checkImagePresent()"
                  >
                    <v-btn
                      v-if="url"
                      size="x-small"
                      icon
                      color="red"
                      variant="flat"
                      class="position-absolute"
                      style="top: -6px; right: -6px"
                      @click.stop="(url = null), (uploadedImage = false)"
                    >
                      <v-icon size="x-small">mdi-close</v-icon>
                    </v-btn>

                    <v-img
                      v-if="url"
                      :src="url"
                      :lazy-src="url"
                      height="56"
                      max-width="160"
                    />

                    <div v-else class="text-center">
                      <input
                        ref="excel-upload-input"
                        type="file"
                        accept="image/*"
                        class="excel-upload-input"
                        @change="handleClick"
                      />
                      <v-icon size="large" class="mb-1">mdi-upload</v-icon>
                      <div class="text-caption">Upload Image</div>
                    </div>
                  </div>
                </OrgSettingsDialogField>

                <OrgSettingsToggleRow
                  v-model="enablecomponent"
                  label="Enable Component Inventory"
                  class="org-settings-page__logo-toggle"
                />

                <div class="org-settings-page__logo-fields">
                  <OrgSettingsDialogField label="Organization Address">
                    <v-text-field
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      v-model="org_address"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField label="Organization Contact Number">
                    <v-text-field
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      v-model="orgContNumber"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField label="Organization Email ID">
                    <v-text-field
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      v-model="orgEmailId"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField label="Call Center Contact Number">
                    <v-text-field
                      color="primary"
                      density="comfortable"
                      readonly
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      v-model="callCenterContNum"
                    />
                  </OrgSettingsDialogField>
                </div>

                <div class="org-settings-page__section-footer">
                  <v-btn
                    :loading="loadingOrganizationLogo"
                    variant="flat"
                    class="primary-btn text-none"
                    @click="saveOrgLogo"
                  >
                    Save
                  </v-btn>
                </div>
          </div>
        </section>

        <section
          v-if="activeCategory === 'attendance'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-page__attendance-section">
            <div class="org-settings-page__attendance-fields">
              <OrgSettingsDialogField label="Auto Logout Time">
                <v-select
                  color="primary"
                  :items="AutoMaticLogoutTime"
                  variant="outlined"
                  density="comfortable"
                  hide-details
                  class="osd-field__input"
                  v-model="time_setting.auto_logout_time"
                />
              </OrgSettingsDialogField>

              <OrgSettingsDialogField label="Weekly Off">
                <v-select
                  color="primary"
                  multiple
                  :items="itemsssss"
                  item-title="text"
                  item-value="value"
                  variant="outlined"
                  density="comfortable"
                  hide-details
                  class="osd-field__input"
                  v-model="time_setting.itemsssss"
                />
              </OrgSettingsDialogField>

              <div class="org-settings-page__attendance-field--full">
                <OrgSettingsDialogField label="Holiday Dates">
                  <SwDatePickerField
                v-model="time_setting.holidaydate"
                v-bind="FILTER_PANEL_CONTROL"
                hide-details
                label=""
              />
                </OrgSettingsDialogField>
              </div>
            </div>

            <div class="org-settings-page__section-footer">
              <v-btn
                :loading="loadingATTENDANCE_SETTINGS"
                variant="flat"
                class="primary-btn text-none"
                @click="validateMethod('ATTENDANCE_SETTINGS')"
              >
                Save
              </v-btn>
            </div>
          </div>
        </section>
        <section
          v-if="activeCategory === 'ticket-settings'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body">
            <OrganizationSettingsTicketSettingsPanel />
          </div>
        </section>
        <section
          v-if="activeCategory === 'feedback-url'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-page__feedback-section">
            <OrgSettingsToggleRow
              v-model="feedback_url_enable"
              label="Enable feedback URL"
            />

            <OrgSettingsDialogField
              v-if="feedback_url_enable != false && feedback_url_enable != undefined"
              label="Feedback URL"
              class="org-settings-page__feedback-field"
            >
              <v-text-field
                color="primary"
                density="comfortable"
                variant="outlined"
                hide-details
                class="osd-field__input"
                v-model="feedback_url"
              />
            </OrgSettingsDialogField>
          </div>
        </section>
        <section
          v-if="activeCategory === 'territory-classification'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__territory-panel">
            <OrgSettingsDialogSection
              title="Add territory"
              icon="mdi-map-marker-plus"
              description="Create a territory name and pincode type rule."
            >
              <v-form ref="territoryForm">
                <div class="org-settings-page__territory-fields">
                  <OrgSettingsDialogField label="Territory Name">
                    <v-text-field
                      color="primary"
                      v-model="Territory_Name"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField label="Select Option">
                    <v-select
                      color="primary"
                      v-model="selection"
                      :items="options"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="selection === 'Hours'"
                    label="Hours"
                  >
                    <v-select
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      v-model="Time_Values"
                      :items="TimeArray"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="selection === 'Days'"
                    label="Select Day"
                  >
                    <v-select
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      :items="territoryClassDays"
                      v-model="formattedDay"
                    />
                  </OrgSettingsDialogField>
                </div>

                <div class="org-settings-page__territory-add-row">
                  <v-tooltip location="top" text="Add territory">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        variant="flat"
                        class="primary-btn org-settings-page__territory-add-btn"
                        :loading="TerritoryLoading"
                        @click.stop="CreatePincodeTypeMethod()"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
              </v-form>
            </OrgSettingsDialogSection>

            <OrgSettingsDialogSection
              title="Territory list"
              icon="mdi-format-list-bulleted"
              description="Manage existing territory names and pincode types."
            >
              <div class="org-settings-page__table-wrap">
                <SwDataTable
                  density="compact"
                  :headers="TerritoriesHeaders"
                  :items="Pincodes_Items"
                  :items-per-page="10"
                  :items-per-page-options="[10, 25, 50]"
                >
                  <template v-slot:[`item.action`]="{ item, index }">
                    <OrgSettingsTableActions
                      show-info
                      @edit="edit_Territory_Method(item, 'EDIT')"
                      @info="ListPincodesHistoryDialogMethod(item)"
                      @delete="deleteTerritoryClassMethod(item, index)"
                    />
                  </template>
                </SwDataTable>
              </div>
            </OrgSettingsDialogSection>
          </div>
        </section>
        <section
          v-if="activeCategory === 'distance-variation'"
          class="org-settings-page__section"
        >
          <OrgSettingsDialogField label="Distance in KMs">
            <v-text-field
              color="primary"
              density="comfortable"
              variant="outlined"
              hide-details
              class="osd-field__input"
              v-model="distance_variation"
            />
          </OrgSettingsDialogField>
        </section>
        <section
          v-if="activeCategory === 'master-category'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__territory-panel">
            <OrgSettingsDialogSection
              title="Add master category"
              icon="mdi-shape-outline"
              description="Select a master category to add to your organization."
            >
              <v-form ref="formMC">
                <div class="org-settings-page__territory-fields org-settings-page__territory-fields--single">
                  <OrgSettingsDialogField label="Select Master Categories">
                    <v-select
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      :rules="[(v) => !!v || 'Required']"
                      class="osd-field__input"
                      :items="GetAllMasterCategoriesList"
                      v-model="masterCategorySettings.category_id"
                      item-title="category_name"
                      item-value="category_id"
                    />
                  </OrgSettingsDialogField>
                </div>

                <div class="org-settings-page__territory-add-row">
                  <v-tooltip location="top" text="Add Master Category">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        variant="flat"
                        class="primary-btn org-settings-page__territory-add-btn"
                        @click="validateMCMethod()"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
              </v-form>
            </OrgSettingsDialogSection>

            <OrgSettingsDialogSection
              title="Master category list"
              icon="mdi-format-list-bulleted"
              description="Categories assigned to this organization."
            >
              <div class="org-settings-page__table-wrap">
                <SwDataTable
                  density="compact"
                  :headers="masterCategoryHeaders"
                  :items="masterCategoryItems"
                  :items-per-page="100"
                  :items-per-page-options="[100, 200, 500]"
                >
                  <template #item.sl_no="{ item }">
                    <span>{{ masterCategoryItems.indexOf(item) + 1 }}</span>
                  </template>
                  <template #item.master_category_name="{ item }">
                    <span>{{ item.master_category_name }}</span>
                  </template>
                  <template #item.Actions="{ item }">
                    <v-tooltip location="top" text="Delete Master Category">
                      <template #activator="{ props }">
                        <v-btn
                          v-bind="props"
                          icon
                          variant="text"
                          size="small"
                          @click="
                            masterCategoryItems.splice(
                              masterCategoryItems.indexOf(item),
                              1,
                            )
                          "
                        >
                          <v-icon size="small" color="red">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </template>
                </SwDataTable>
              </div>
            </OrgSettingsDialogSection>
          </div>
        </section>
        <section
          v-if="activeCategory === 'category-settings'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__territory-panel">
            <OrgSettingsDialogSection
              title="Add category"
              icon="mdi-folder-outline"
              description="Map a service category to a master category."
            >
              <v-form ref="formC">
                <div class="org-settings-page__territory-fields">
                  <OrgSettingsDialogField label="Select Master Categories">
                    <v-select
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      :items="masterCategoryItems"
                      item-title="master_category_name"
                      item-value="master_category_id"
                      v-model="categorySettings.master_category_id"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField label="Select Categories">
                    <v-select
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      item-title="category_name"
                      item-value="category_id"
                      v-model="categorySettings.category_id"
                      :items="GetCategoriesByMasterCategoryList"
                    />
                  </OrgSettingsDialogField>
                </div>

                <div class="org-settings-page__territory-add-row">
                  <v-tooltip location="top" text="Add Category">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        variant="flat"
                        class="primary-btn org-settings-page__territory-add-btn"
                        @click="validateCMethod()"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
              </v-form>
            </OrgSettingsDialogSection>

            <OrgSettingsDialogSection
              title="Category list"
              icon="mdi-format-list-bulleted"
              description="Service categories linked to master categories."
            >
              <div class="org-settings-page__table-wrap">
                <SwDataTable
                  density="compact"
                  :headers="categoryHeaders"
                  :items="categoryItems"
                  :items-per-page="100"
                  :items-per-page-options="[100, 200, 500]"
                >
                  <template #item.sl_no="{ item }">
                    <span>{{ categoryItems.indexOf(item) + 1 }}</span>
                  </template>
                  <template #item.master_category_name="{ item }">
                    <span>{{ item.master_category_name }}</span>
                  </template>
                  <template #item.category_name="{ item }">
                    <span>{{ item.category_name }}</span>
                  </template>
                  <template #item.Actions="{ item }">
                    <v-tooltip location="top" text="Delete Category">
                      <template #activator="{ props }">
                        <v-btn
                          v-bind="props"
                          icon
                          variant="text"
                          size="small"
                          @click="
                            categoryItems.splice(
                              categoryItems.indexOf(item),
                              1,
                            )
                          "
                        >
                          <v-icon size="small" color="red">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </template>
                </SwDataTable>
              </div>
            </OrgSettingsDialogSection>
          </div>
        </section>
        <section
          v-if="activeCategory === 'close-ticket'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__territory-panel">
            <OrgSettingsDialogSection
              title="Location & closure"
              icon="mdi-map-marker-check-outline"
              description="Configure location and closure type requirements when closing tickets."
            >
              <div class="org-settings-page__close-ticket-toggles">
                <OrgSettingsToggleRow
                  v-model="is_close_ticket_location_enable"
                  label="Enable Close Ticket Location Type"
                />
                <OrgSettingsDialogField
                  v-if="is_close_ticket_location_enable != false"
                  label="Ticket Location Type"
                  class="org-settings-page__close-ticket-field"
                >
                  <v-autocomplete
                    color="primary"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                    :items="ticket_location_type_items"
                    item-title="text"
                    item-value="value"
                  />
                </OrgSettingsDialogField>

                <OrgSettingsToggleRow
                  v-model="is_clouser_type_enable"
                  label="Closure Type"
                />
                <OrgSettingsDialogField
                  v-if="is_clouser_type_enable != false"
                  label="Ticket Closure Type"
                  class="org-settings-page__close-ticket-field"
                >
                  <v-autocomplete
                    color="primary"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                    :items="closure_type_items"
                    item-title="text"
                    item-value="value"
                  />
                </OrgSettingsDialogField>
              </div>
            </OrgSettingsDialogSection>

            <OrgSettingsDialogSection
              title="OTP & training"
              icon="mdi-cellphone-key"
              description="OTP delivery and training acknowledgement on ticket close."
            >
              <div class="org-settings-page__close-ticket-fields">
                <OrgSettingsDialogField label="Send OTP While Closing Ticket To">
                  <v-select
                    color="primary"
                    v-model="is_otp_send_to"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                    :items="send_otp_to_items"
                    item-title="text"
                    item-value="value"
                    :rules="[(v) => !!v || 'Required']"
                  />
                </OrgSettingsDialogField>
              </div>

              <OrgSettingsToggleRow
                v-model="is_training_provided_to"
                label="Training Provided to"
                class="org-settings-page__close-ticket-toggle"
              />
            </OrgSettingsDialogSection>
          </div>
        </section>
        <section
          v-if="activeCategory === 'escalation'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__territory-panel">
            <OrgSettingsDialogSection
              title="Notification schedule"
              icon="mdi-bell-alert-outline"
              description="Enable escalation alerts and set the notification interval."
            >
              <OrgSettingsToggleRow
                v-model="escalation_notification_enable"
                label="Enable Escalation Notification"
              />

              <OrgSettingsDialogField
                v-if="escalation_notification_enable === true"
                label="Days"
                class="org-settings-page__close-ticket-field"
              >
                <v-select
                  color="primary"
                  variant="outlined"
                  density="comfortable"
                  hide-details
                  class="osd-field__input"
                  v-model="escalation_day"
                  :items="escalation_day_items"
                  item-title="text"
                  item-value="value"
                />
              </OrgSettingsDialogField>
            </OrgSettingsDialogSection>

            <OrgSettingsDialogSection
              title="Recipient users"
              icon="mdi-account-multiple-outline"
              description="Choose which users receive escalation notifications."
            >
              <OrgSettingsToggleRow
                v-model="enable_user_select"
                label="Enable To Select Users"
              />

              <OrgSettingsDialogField
                v-if="enable_user_select"
                label="Select Users"
                class="org-settings-page__close-ticket-field"
              >
                <v-select
                  color="primary"
                  variant="outlined"
                  density="comfortable"
                  hide-details
                  class="osd-field__input"
                  v-model="escalation_user"
                  :items="escalation_user_items"
                  multiple
                  chips
                  closable-chips
                >
                  <template #selection="{ index }">
                    <v-chip v-if="index === 0" size="x-small">
                      <span>{{ escalation_user[0] }}</span>
                    </v-chip>
                    <span
                      v-if="index === 0 && escalation_user.length > 1"
                      class="org-settings-page__multi-select-more"
                    >
                      (+{{ escalation_user.length - 1 }} others)
                    </span>
                  </template>
                </v-select>
              </OrgSettingsDialogField>
            </OrgSettingsDialogSection>
          </div>
        </section>
        <section
          v-if="activeCategory === 'ticket-discard'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-page__feedback-section">
            <OrgSettingsToggleRow
              v-model="ticket_discard"
              label="Enable Ticket Discard"
            />
          </div>
        </section>
        <section
          v-if="activeCategory === 'ticket-workflow'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-twf">
            <OrgSettingsDialogSection
              title="Accept / reject timing"
              icon="mdi-clock-check-outline"
              description="Set how long tickets can remain before accept or reject expires."
            >
              <OrgSettingsToggleRow
                v-model="enable_ticket_accept"
                label="Ticket Accept or Reject"
              />

              <div
                v-if="enable_ticket_accept"
                class="org-settings-twf__fields"
              >
                <OrgSettingsDialogField label="Days / Hours">
                  <v-autocomplete
                    color="primary"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                    v-model="days_or_hours"
                    :items="days_or_hours_items"
                    item-title="text"
                    item-value="value"
                    :rules="
                      enable_ticket_accept
                        ? [(v) => !!v || 'Required']
                        : []
                    "
                  />
                </OrgSettingsDialogField>

                <OrgSettingsDialogField label="Ticket Accept Time">
                  <v-combobox
                    color="primary"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                    v-model="ticket_accept_time"
                    :items="
                      days_or_hours == 'DAYS'
                        ? ticket_accept_time_items
                        : ticket_accept_time_items_hours
                    "
                    :rules="
                      enable_ticket_accept
                        ? [(v) => !!v || 'Required']
                        : []
                    "
                  />
                </OrgSettingsDialogField>
              </div>
            </OrgSettingsDialogSection>

            <OrgSettingsDialogSection
              title="Close ticket workflow"
              icon="mdi-sitemap-outline"
              description="Enable workflow and assign close-ticket approval by role."
            >
              <OrgSettingsToggleRow
                v-model="enable_ticket_close_workflow"
                label="Enable Close Ticket Workflow"
              />

              <div
                v-if="enable_ticket_close_workflow"
                class="org-settings-twf__permissions"
              >
                <h3 class="org-settings-twf__permissions-title">
                  Close ticket approval levels
                </h3>
                <p class="org-settings-twf__permissions-desc">
                  Choose which roles can approve ticket closure at each hierarchy
                  level.
                </p>

                <div class="org-settings-twf__columns">
                  <div
                    v-for="column in ticketWorkflowColumns"
                    :key="column.id"
                    class="org-settings-twf__column"
                    :class="`org-settings-twf__column--${column.accent}`"
                  >
                    <header class="org-settings-twf__column-header">
                      <div class="org-settings-twf__column-heading">
                        <span class="org-settings-twf__column-icon-wrap">
                          <v-icon :icon="column.icon" size="18" />
                        </span>
                        <span class="org-settings-twf__column-title">{{
                          column.title
                        }}</span>
                      </div>
                      <div class="org-settings-twf__column-actions">
                        <button
                          v-if="twfParentActive(column.parentKey)"
                          type="button"
                          class="org-settings-twf__select-all"
                          :class="{
                            'org-settings-twf__select-all--active':
                              isAllTwfRolesSelected(column),
                          }"
                          @click="toggleAllTwfRoles(column)"
                        >
                          {{ twfAllToggleLabel(column) }}
                        </button>
                        <button
                          type="button"
                          class="org-settings-twf__switch org-settings-twf__switch--sm"
                          :class="{
                            'org-settings-twf__switch--on': twfParentActive(
                              column.parentKey,
                            ),
                          }"
                          role="switch"
                          :aria-checked="twfParentActive(column.parentKey)"
                          :aria-label="`Enable ${column.title}`"
                          @click="toggleTwfParent(column.parentKey)"
                        >
                          <span class="org-settings-twf__switch-thumb" />
                        </button>
                      </div>
                    </header>

                    <div
                      v-if="twfParentActive(column.parentKey)"
                      class="org-settings-twf__column-body"
                    >
                      <div class="org-settings-twf__pills">
                        <button
                          v-for="role in column.roles"
                          :key="role.key"
                          type="button"
                          class="org-settings-twf__pill"
                          :class="{
                            'org-settings-twf__pill--active': isTwfRoleActive(
                              role.key,
                            ),
                          }"
                          @click="toggleTwfRole(role.key)"
                        >
                          {{ role.label }}
                        </button>
                      </div>
                    </div>
                    <p v-else class="org-settings-twf__column-disabled">
                      Enable this level to assign roles.
                    </p>
                  </div>
                </div>
              </div>
            </OrgSettingsDialogSection>
          </div>
        </section>
        <section
          v-if="activeCategory === 'auto-convert-support'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-page__feedback-section">
            <OrgSettingsToggleRow
              v-model="is_enabled_to_update_shceduled_service"
              label="Auto Convert Support and Support Type after Support End Date Complete"
            />

            <div
              v-if="
                is_enabled_to_update_shceduled_service != false &&
                is_enabled_to_update_shceduled_service != undefined
              "
              class="org-settings-page__attendance-fields"
            >
              <OrgSettingsDialogField label="Support">
                <v-autocomplete
                  color="primary"
                  density="comfortable"
                  variant="outlined"
                  hide-details
                  class="osd-field__input"
                  v-model="support_type"
                  :items="support_type_items"
                  item-title="text"
                  item-value="value"
                />
              </OrgSettingsDialogField>

              <OrgSettingsDialogField label="Support Type">
                <v-autocomplete
                  color="primary"
                  density="comfortable"
                  variant="outlined"
                  hide-details
                  class="osd-field__input"
                  v-model="warranty_type"
                  item-title="setting_name"
                  item-value="setting_name"
                  :items="GetAllAMCTypeList"
                />
              </OrgSettingsDialogField>
            </div>
          </div>
        </section>
        <section
          v-if="activeCategory === 'workflow-settings'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-twf">
            <v-form ref="form_workflow_settings">
              <OrgSettingsDialogSection
                title="Components"
                icon="mdi-cog-box"
                description="Approval workflow for component requests."
              >
                <OrgSettingsToggleRow
                  v-model="workflow_enabled"
                  label="Enable workflow"
                />

                <div
                  v-if="workflow_enabled != false"
                  class="org-settings-twf__fields"
                >
                  <OrgSettingsDialogField label="Component Approver">
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      item-title="text"
                      item-value="value"
                      v-model="approver"
                      :items="approver_items"
                      :rules="
                        workflow_enabled == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="
                      approver == 'SPECIFIC_USERS' ||
                      approver == 'REPORTING_MANAGER_AND_SPECIFIC_USER'
                    "
                    label="Users"
                  >
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      multiple
                      class="osd-field__input"
                      item-value="user_id"
                      item-title="user_name"
                      v-model="approver_ids"
                      :items="GetAllUsersList"
                      :rules="
                        approver == 'SPECIFIC_USERS'
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>
                </div>
              </OrgSettingsDialogSection>

              <OrgSettingsDialogSection
                title="Product Fleet"
                icon="mdi-truck-delivery-outline"
                description="Approval workflow for product fleet changes."
              >
                <OrgSettingsToggleRow
                  v-model="enable_product_fleet_workflow"
                  label="Enable workflow"
                />

                <div
                  v-if="enable_product_fleet_workflow != false"
                  class="org-settings-twf__fields"
                >
                  <OrgSettingsDialogField label="Product Fleet Approver">
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      item-title="text"
                      item-value="value"
                      :items="approver_items"
                      v-model="product_fleet_approver"
                      :rules="
                        enable_product_fleet_workflow == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="
                      product_fleet_approver == 'SPECIFIC_USERS' ||
                      product_fleet_approver ==
                        'REPORTING_MANAGER_AND_SPECIFIC_USER'
                    "
                    label="Users"
                  >
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      item-value="user_id"
                      item-title="user_name"
                      :items="GetAllUsersList"
                      v-model="product_fleet_approver_id"
                      :rules="
                        product_fleet_approver == 'SPECIFIC_USERS'
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>
                </div>
              </OrgSettingsDialogSection>

              <OrgSettingsDialogSection
                title="Quotations"
                icon="mdi-file-document-outline"
                description="Approval workflow for quotations."
              >
                <OrgSettingsToggleRow
                  v-model="enable_workflow_for_quotation"
                  label="Enable workflow"
                />

                <div
                  v-if="enable_workflow_for_quotation != false"
                  class="org-settings-twf__fields"
                >
                  <OrgSettingsDialogField label="Quotations Approver">
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      item-title="text"
                      item-value="value"
                      :items="approver_items"
                      v-model="quotation_approver"
                      :rules="
                        enable_workflow_for_quotation == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="
                      quotation_approver == 'SPECIFIC_USERS' ||
                      quotation_approver ==
                        'REPORTING_MANAGER_AND_SPECIFIC_USER'
                    "
                    label="Users"
                  >
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      multiple
                      class="osd-field__input"
                      item-value="user_id"
                      item-title="user_name"
                      :items="GetAllUsersList"
                      v-model="quotation_approver_ids"
                      :rules="
                        product_fleet_approver == 'SPECIFIC_USERS'
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>
                </div>
              </OrgSettingsDialogSection>

              <OrgSettingsDialogSection
                title="Quotation MRF"
                icon="mdi-file-chart-outline"
                description="Approval workflow for quotation MRF requests."
              >
                <OrgSettingsToggleRow
                  v-model="enable_workflow_for_quotation_mrf"
                  label="Enable workflow"
                />

                <div
                  v-if="enable_workflow_for_quotation_mrf != false"
                  class="org-settings-twf__fields"
                >
                  <OrgSettingsDialogField label="Quotation MRF Approver">
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      item-title="text"
                      item-value="value"
                      :items="approver_items"
                      v-model="quotation_mrf_approver"
                      :rules="
                        enable_workflow_for_quotation_mrf == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="
                      quotation_mrf_approver == 'SPECIFIC_USERS' ||
                      quotation_mrf_approver ==
                        'REPORTING_MANAGER_AND_SPECIFIC_USER'
                    "
                    label="Users"
                  >
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      multiple
                      class="osd-field__input"
                      item-value="user_id"
                      item-title="user_name"
                      :items="GetAllUsersList"
                      v-model="quotation_mrf_approver_ids"
                      :rules="
                        product_fleet_approver == 'SPECIFIC_USERS'
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>
                </div>
              </OrgSettingsDialogSection>

              <OrgSettingsDialogSection
                title="Product Replacement"
                icon="mdi-swap-horizontal"
                description="Approval workflow for product replacement (FGR)."
              >
                <OrgSettingsToggleRow
                  v-model="enable_workflow_for_fgr"
                  label="Enable workflow"
                />

                <div
                  v-if="enable_workflow_for_fgr != false"
                  class="org-settings-twf__fields"
                >
                  <OrgSettingsDialogField label="Product Replacement Approver">
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      item-title="text"
                      item-value="value"
                      :items="fgr_approver_items"
                      v-model="fgr_approver"
                      :rules="
                        enable_workflow_for_fgr == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="
                      fgr_approver === 'TECHNICAL_MANAGERS_AND_SPECIFIC_USER' ||
                      fgr_approver === 'TECHNICAL_MANAGERS'
                    "
                    label="Technical Managers"
                  >
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      multiple
                      class="osd-field__input"
                      item-title="user_name"
                      item-value="user_id"
                      :items="fgrTechManagers"
                      v-model="fgr_tech_manager_approver_ids"
                      :rules="
                        product_fleet_approver == 'SPECIFIC_USERS'
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="
                      fgr_approver == 'SPECIFIC_USERS' ||
                      fgr_approver == 'REPORTING_MANAGER_AND_SPECIFIC_USER' ||
                      fgr_approver === 'TECHNICAL_MANAGERS_AND_SPECIFIC_USER'
                    "
                    label="Specific Users"
                  >
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      multiple
                      class="osd-field__input"
                      item-value="user_id"
                      item-title="user_name"
                      :items="GetAllUsersList"
                      v-model="fgr_approver_ids"
                      :rules="
                        product_fleet_approver == 'SPECIFIC_USERS'
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>
                </div>
              </OrgSettingsDialogSection>

              <OrgSettingsDialogSection
                title="FOC"
                icon="mdi-gift-outline"
                description="Approval workflow for free-of-charge requests."
              >
                <OrgSettingsToggleRow
                  v-model="enable_workflow_for_foc"
                  label="Enable workflow"
                />

                <div
                  v-if="enable_workflow_for_foc != false"
                  class="org-settings-twf__fields"
                >
                  <OrgSettingsDialogField label="FOC Approver">
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      item-title="text"
                      item-value="value"
                      :items="fgr_approver_items"
                      v-model="foc_approver"
                      :rules="
                        enable_workflow_for_foc == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="
                      foc_approver === 'TECHNICAL_MANAGERS_AND_SPECIFIC_USER' ||
                      foc_approver === 'TECHNICAL_MANAGERS'
                    "
                    label="Technical Managers"
                  >
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      multiple
                      class="osd-field__input"
                      item-value="user_id"
                      item-title="user_name"
                      :items="focTechManagers"
                      v-model="foc_tech_manager_approver_ids"
                      :rules="
                        product_fleet_approver == 'SPECIFIC_USERS'
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="
                      foc_approver == 'SPECIFIC_USERS' ||
                      foc_approver == 'REPORTING_MANAGER_AND_SPECIFIC_USER' ||
                      foc_approver === 'TECHNICAL_MANAGERS_AND_SPECIFIC_USER'
                    "
                    label="Specific Users"
                  >
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      multiple
                      class="osd-field__input"
                      item-value="user_id"
                      item-title="user_name"
                      :items="GetAllUsersList"
                      v-model="foc_approver_ids"
                      :rules="
                        product_fleet_approver == 'SPECIFIC_USERS'
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>
                </div>
              </OrgSettingsDialogSection>

              <OrgSettingsDialogSection
                title="Payout"
                icon="mdi-cash-multiple"
                description="Approval workflow for payout requests."
              >
                <OrgSettingsToggleRow
                  v-model="enable_payout"
                  label="Enable workflow"
                />

                <div
                  v-if="enable_payout != false"
                  class="org-settings-twf__fields"
                >
                  <OrgSettingsDialogField label="Payout Approver">
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      item-title="text"
                      item-value="value"
                      :items="approver_items"
                      v-model="payout_approver"
                      :rules="
                        enable_payout == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField
                    v-if="
                      payout_approver == 'SPECIFIC_USERS' ||
                      payout_approver == 'REPORTING_MANAGER_AND_SPECIFIC_USER'
                    "
                    label="Users"
                  >
                    <v-autocomplete
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      multiple
                      class="osd-field__input"
                      item-value="user_id"
                      item-title="user_name"
                      :items="GetAllUsersList"
                      v-model="payout_approver_ids"
                    />
                  </OrgSettingsDialogField>
                </div>
              </OrgSettingsDialogSection>
            </v-form>
          </div>
        </section>
        <section
          v-if="activeCategory === 'custom-ticket-id'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-twf">
            <OrgSettingsDialogSection
              title="Custom ticket ID"
              icon="mdi-identifier"
              description="Generate ticket IDs using configurable prefixes and sequence rules."
            >
              <OrgSettingsToggleRow
                v-model="enable_to_generate_custome_based_ticket_id"
                label="Enable Custom Ticket ID"
              />
            </OrgSettingsDialogSection>

            <template v-if="enable_to_generate_custome_based_ticket_id == true">
              <OrgSettingsDialogSection
                title="Prefix options"
                icon="mdi-tag-outline"
                description="Optional prefixes included in the ticket ID format."
              >
                <div class="org-settings-page__close-ticket-toggles">
                  <OrgSettingsToggleRow
                    v-model="enable_organization_prefix"
                    label="Enable Organization Prefix"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_organization_prefix == true"
                    label="Prefix Value"
                    class="org-settings-page__close-ticket-field"
                  >
                    <v-text-field
                      color="primary"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="osd-field__input"
                      hint="Min 1, Max 3 Chars"
                      persistent-hint
                      :disabled="
                        enable_organization_prefix == false ||
                        enable_organization_prefix == undefined
                      "
                      v-model="organization_prefix_value"
                      :rules="
                        enable_organization_prefix == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                      :maxlength="3"
                      @keyup="callmethodUppercase(organization_prefix_value)"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsToggleRow
                    v-model="enable_call_type"
                    label="Enable Call Type"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_call_type == true"
                    label="Call Type Prefix Chars"
                    class="org-settings-page__close-ticket-field"
                  >
                    <v-autocomplete
                      color="primary"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="osd-field__input"
                      :disabled="
                        enable_call_type == false ||
                        enable_call_type == undefined
                      "
                      :rules="
                        enable_call_type == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                      v-model="call_type_prefix"
                      :items="call_type_prefix_chars_items"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsToggleRow
                    v-model="enable_category_prefix"
                    label="Enable Category Prefix"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_category_prefix == true"
                    label="Category Prefix Chars"
                    class="org-settings-page__close-ticket-field"
                  >
                    <v-autocomplete
                      color="primary"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="osd-field__input"
                      :disabled="
                        enable_category_prefix == false ||
                        enable_category_prefix == undefined
                      "
                      :rules="
                        enable_category_prefix == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                      v-model="category_prefix"
                      :items="category_prefix_items"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsToggleRow
                    v-model="enable_product_prefix"
                    label="Enable Product Prefix"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_product_prefix == true"
                    label="Product Prefix Chars"
                    class="org-settings-page__close-ticket-field"
                  >
                    <v-autocomplete
                      color="primary"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="osd-field__input"
                      :disabled="
                        enable_product_prefix == false ||
                        enable_product_prefix == undefined
                      "
                      :rules="
                        enable_product_prefix == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                      v-model="product_prefix"
                      :items="product_prefix_items"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsToggleRow
                    v-model="enable_product_fleet_prefix"
                    label="Enable Product Fleet Prefix"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_product_fleet_prefix == true"
                    label="Product Fleet Prefix Chars"
                    class="org-settings-page__close-ticket-field"
                  >
                    <v-autocomplete
                      color="primary"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="osd-field__input"
                      :disabled="
                        enable_product_fleet_prefix == false ||
                        enable_product_fleet_prefix == undefined
                      "
                      :rules="
                        enable_product_fleet_prefix == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                      v-model="product_fleet_prefix"
                      :items="product_fleet_prefix_items"
                    />
                  </OrgSettingsDialogField>
                </div>
              </OrgSettingsDialogSection>

              <OrgSettingsDialogSection
                title="Sequence & format"
                icon="mdi-counter"
                description="Date, sequence, separator, and field order for ticket IDs."
              >
                <div class="org-settings-page__close-ticket-toggles">
                  <OrgSettingsToggleRow
                    v-model="enable_date_of_ticket_register"
                    label="Enable Date of Ticket"
                  />
                  <OrgSettingsToggleRow
                    v-model="enable_ticket_sequence"
                    label="Enable Ticket Sequence"
                  />

                  <OrgSettingsToggleRow
                    v-model="enable_ticket_sequence_reset"
                    label="Enable Ticket Sequence Reset"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_ticket_sequence_reset == true"
                    label="Ticket Sequence Reset By"
                    class="org-settings-page__close-ticket-field"
                  >
                    <v-autocomplete
                      color="primary"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="osd-field__input"
                      :disabled="
                        enable_ticket_sequence_reset == false ||
                        enable_ticket_sequence_reset == undefined
                      "
                      :rules="
                        enable_ticket_sequence_reset == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                      v-model="ticket_sequence_reset"
                      :items="ticket_sequence_reset_items"
                      item-title="text"
                      item-value="value"
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsToggleRow
                    v-model="enable_ticket_separator"
                    label="Enable Ticket Separator"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_ticket_separator == true"
                    label="Separator"
                    class="org-settings-page__close-ticket-field"
                  >
                    <v-autocomplete
                      color="primary"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="osd-field__input"
                      :disabled="
                        enable_ticket_separator == false ||
                        enable_ticket_separator == undefined
                      "
                      v-model="ticket_separator"
                      :items="ticket_separator_items"
                      item-title="text"
                      item-value="value"
                    />
                  </OrgSettingsDialogField>
                </div>

                <OrgSettingsDialogField
                  label="Ticket ID Sequence"
                  class="org-settings-page__ticket-id-sequence"
                >
                  <v-autocomplete
                    color="primary"
                    variant="outlined"
                    density="comfortable"
                    hide-details
                    multiple
                    class="osd-field__input"
                    :rules="
                      enable_to_generate_custome_based_ticket_id == true
                        ? [(v) => !!v || 'Required']
                        : []
                    "
                    v-model="ticket_create_sequence"
                    :items="ticket_create_sequence_items"
                    item-title="text"
                    item-value="value"
                  />
                </OrgSettingsDialogField>
              </OrgSettingsDialogSection>
            </template>
          </div>
        </section>
        <section
          v-if="activeCategory === 'custom-report-builder'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-page__report-builder">
            <ReportDownloadFields @clicked="reportsFieldsEmit" />
          </div>
        </section>
        <section
          v-if="activeCategory === 'bank-account'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body">
            <v-form ref="bank_details_form">
              <div class="org-settings-page__attendance-fields">
                <OrgSettingsDialogField label="Bank Name">
                  <v-text-field
                    color="primary"
                    :rules="[(v) => !!v || 'Required']"
                    v-model="bank_name"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                  />
                </OrgSettingsDialogField>

                <OrgSettingsDialogField label="Bank Address">
                  <v-text-field
                    color="primary"
                    v-model="bank_address"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                  />
                </OrgSettingsDialogField>

                <OrgSettingsDialogField label="Account Holder Name">
                  <v-text-field
                    color="primary"
                    :rules="[(v) => !!v || 'Required']"
                    v-model="account_holder"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                  />
                </OrgSettingsDialogField>

                <OrgSettingsDialogField label="Account Number">
                  <v-text-field
                    color="primary"
                    :rules="[(v) => !!v || 'Required']"
                    v-model="account_id"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                  />
                </OrgSettingsDialogField>

                <OrgSettingsDialogField label="IFSC Code">
                  <v-text-field
                    color="primary"
                    :rules="[(v) => !!v || 'Required']"
                    v-model="ifsc"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                  />
                </OrgSettingsDialogField>

                <OrgSettingsDialogField label="Branch">
                  <v-text-field
                    color="primary"
                    :rules="[(v) => !!v || 'Required']"
                    v-model="branch"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                  />
                </OrgSettingsDialogField>

                <OrgSettingsDialogField label="GST Number">
                  <v-text-field
                    color="primary"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                    v-model="tax_id"
                  />
                </OrgSettingsDialogField>

                <OrgSettingsDialogField label="Pan Number">
                  <v-text-field
                    color="primary"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                    v-model="pan_no"
                  />
                </OrgSettingsDialogField>

                <OrgSettingsDialogField label="UPI ID">
                  <v-text-field
                    color="primary"
                    v-model="upiId"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    class="osd-field__input"
                    :rules="[(v) => !!v || 'Required']"
                  />
                </OrgSettingsDialogField>
              </div>
            </v-form>
          </div>
        </section>
        <section
          v-if="
            activeCategory === 'quotation-settings' &&
            $store.getters.get_current_user_details.organization_details
              .enable_quotation_generation === true
          "
          class="org-settings-page__section"
        >
          <div class="org-settings-page__territory-panel">
            <OrgSettingsDialogSection
              title="Quotation defaults"
              icon="mdi-file-document-edit-outline"
              description="Terms, conditions, and discount limits for quotations."
            >
              <v-form ref="quotation_settings_form">
                <div class="org-settings-page__feedback-section">
                  <OrgSettingsToggleRow
                    v-model="enable_terms_and_conditions"
                    label="Enable Terms & Conditions while Generating Quotation"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_terms_and_conditions == true"
                    label="Terms & Conditions"
                    class="org-settings-page__feedback-field"
                  >
                    <v-textarea
                      color="primary"
                      rows="3"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="osd-field__input"
                      v-model="terms_and_conditions"
                      :rules="
                        enable_terms_and_conditions == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsToggleRow
                    v-model="enable_discount"
                    label="Enable Discount"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_discount == true"
                    label="Discount %"
                    class="org-settings-page__close-ticket-field"
                  >
                    <v-text-field
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      v-model="maximum_discount"
                      type="number"
                      :rules="
                        enable_discount == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>
                </div>
              </v-form>
            </OrgSettingsDialogSection>

            <OrgSettingsDialogSection
              title="Service details"
              icon="mdi-wrench-outline"
              description="Manage service charges shown on quotations."
            >
              <div class="org-settings-page__territory-add-row">
                <v-spacer />
                <v-btn
                  variant="flat"
                  class="primary-btn text-none"
                  @click="AddServiceDetailsDialogMethod({}, undefined, 'ADD')"
                >
                  Add Service
                  <v-icon end>mdi-plus</v-icon>
                </v-btn>
              </div>

              <div class="org-settings-page__table-wrap">
                <v-data-table
                  v-if="
                    $store.getters.get_current_user_details.organization_details
                      .quotation_service_charges
                  "
                  :headers="quotationServiceHeader"
                  :items="
                    $store.getters.get_current_user_details.organization_details
                      .quotation_service_charges
                  "
                  :no-data-text="
                    $store.getters.get_current_user_details.organization_details
                      .quotation_service_charges.length === 0
                      ? 'No data available'
                      : ''
                  "
                  :items-per-page="5"
                >
                  <template v-slot:[`item.actions`]="{ item, index }">
                    <OrgSettingsTableActions
                      @edit="AddServiceDetailsDialogMethod(item, index, 'EDIT')"
                      @delete="
                        AddServiceDetailsDialogMethod(item, index, 'DELETE')
                      "
                    />
                  </template>
                </v-data-table>
              </div>
            </OrgSettingsDialogSection>
          </div>
        </section>
        <section
          v-if="
            activeCategory === 'purchase-order-settings' &&
            $store.getters.get_current_user_details.organization_details
              .enable_purchase_order_generation === true
          "
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-twf">
            <OrgSettingsDialogSection
              title="Purchase order defaults"
              icon="mdi-cart-outline"
              description="Terms, conditions, and narration for purchase orders."
            >
              <v-form ref="quotation_settings_form">
                <div class="org-settings-page__feedback-section">
                  <OrgSettingsToggleRow
                    v-model="enable_po_terms_and_conditions"
                    label="Enable Terms & Conditions while Generating PO"
                  />
                  <OrgSettingsDialogField
                    v-if="enable_po_terms_and_conditions == true"
                    label="Terms & Conditions"
                    class="org-settings-page__feedback-field"
                  >
                    <v-textarea
                      color="primary"
                      rows="3"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      class="osd-field__input"
                      v-model="po_terms_and_conditions"
                      :rules="
                        enable_po_terms_and_conditions == true
                          ? [(v) => !!v || 'Required']
                          : []
                      "
                    />
                  </OrgSettingsDialogField>

                  <OrgSettingsDialogField label="Narration">
                    <v-text-field
                      color="primary"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      class="osd-field__input"
                      v-model="po_narration"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </OrgSettingsDialogField>
                </div>
              </v-form>
            </OrgSettingsDialogSection>
          </div>
        </section>
        <section
          v-if="activeCategory === 'product-replacement'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-page__feedback-section">
            <OrgSettingsToggleRow
              v-model="enableFgrTC"
              label="Enable Product Replacement T&C"
            />

            <template v-if="enableFgrTC">
              <OrgSettingsDialogField label="Product Replacement Terms and Conditions">
                <v-textarea
                  color="primary"
                  v-model="fgrTermsCond"
                  density="comfortable"
                  variant="outlined"
                  hide-details
                  class="osd-field__input"
                  rows="3"
                />
              </OrgSettingsDialogField>

              <OrgSettingsDialogField label="Customer Terms and Conditions">
                <v-textarea
                  color="primary"
                  v-model="customerTermsCond"
                  density="comfortable"
                  variant="outlined"
                  hide-details
                  class="osd-field__input"
                  rows="3"
                />
              </OrgSettingsDialogField>

              <OrgSettingsDialogField label="Dealer Terms and Conditions">
                <v-textarea
                  color="primary"
                  v-model="dealerTermsCond"
                  density="comfortable"
                  variant="outlined"
                  hide-details
                  class="osd-field__input"
                  rows="3"
                />
              </OrgSettingsDialogField>
            </template>
          </div>
        </section>

        <section
          v-if="activeCategory === 'payout-settings'"
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body">
            <div class="org-settings-page__attendance-fields">
              <OrgSettingsDialogField label="Bill Period From Date">
                <SwDatePickerField
                v-model="billPeriodFrom"
                v-bind="FILTER_PANEL_CONTROL"
                hide-details
                label=""
                @apply="formatedBillPeriodFrom"
              />
              </OrgSettingsDialogField>
            </div>
          </div>
        </section>
        <section
          v-if="
            activeCategory === 'web-hook' &&
            $store.getters.get_current_user_details.organization_details
              .is_enabled_api_endpoints
          "
          class="org-settings-page__section"
        >
          <div class="org-settings-page__section-body org-settings-page__webhook-section">
            <p class="org-settings-page__webhook-desc">
              View and manage API webhook endpoints configured for your
              organization.
            </p>
            <v-btn
              v-if="!hideWebHookViewButton"
              variant="flat"
              class="primary-btn text-none"
              @click="hideWebHookViewButton = true"
            >
              View webhooks
            </v-btn>
          </div>
        </section>

      <template v-if="activeCategory === 'distance-variation'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="isLoading_distance_variation"
            @click="saveSettingsMethod('DISTANCE_VARIATION')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'ticket-settings'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loadingTICKET_SETTINGS"
            @click="validateMethod('TICKET_SETTINGS')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'feedback-url'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="isLoading"
            @click="saveSettingsMethod('FEEDBACK_URL')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'master-category'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loadingMASTER_CATEGORY_SETTINGS"
            @click="validateMethod('MASTER_CATEGORY_SETTINGS')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'category-settings'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loadingCATEGORY_SETTINGS"
            @click="validateMethod('CATEGORY_SETTINGS')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'close-ticket'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loading_enable_location_btn_while_close_ticket"
            @click="validateMethod('CLOSE_LOCATION_ENABLE')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'escalation'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loading_escalation_enable"
            @click="validateMethod('ESCALATION')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'ticket-discard'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loading_discard_ticket_btn"
            @click="validateMethod('TICKET_DISCARD')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'ticket-workflow'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loading_enable_ticket_accept_btn"
            @click="validateMethod('TICKET_WORKFLOW')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'auto-convert-support'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="btn_update_support_and_support_type"
            @click="validateMethod('UPDATE_SUPPORT_AND_SUPPORT_TYPE')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'workflow-settings'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="btn_loading_workflow_settings"
            @click="validateMethod('WORK_FLOW')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'custom-ticket-id'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="btn_custom_ticket_id"
            @click="validateMethod('UPDATE_CUSTOME_BASED_TICKET_ID')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'bank-account'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loading_bank_details_btn"
            @click="validateMethod('BANK_DETAILS')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'quotation-settings'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loading_quotation_settings_btn"
            @click="saveQuotationDetails()"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'purchase-order-settings'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loading_quotation_settings_btn"
            @click="saveSettingsMethod('PO_DETAILS')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'product-replacement'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loading_quotation_settings_btn"
            @click="saveSettingsMethod('PRODUCT_REPLACEMENT_DETAILS')"
          >
            Save
          </v-btn>
        </div>
      </template>

      <template v-if="activeCategory === 'payout-settings'" #footer>
        <div class="org-settings-dialog__footer-actions">
          <v-btn
            variant="flat"
            class="primary-btn text-none"
            :loading="loading_bank_details_btn"
            @click="validateMethod('PAYOUT')"
          >
            Save
          </v-btn>
        </div>
      </template>
    </OrganizationSettingsDetailDialog>
  </div>
</template>

<script>
// var aws = require("aws-sdk");
// import { Buffer } from "buffer";
// window.Buffer = Buffer;
// import VueClipboard from "vue-clipboard2";
// VueClipboard.config.autoSetContainer = true;
import Overlay from "@/components/Extras/OverlayView.vue";
import Snackbar from "@/components/Extras/SnackbarView.vue";
import ReportDownloadFields from "@/components/MasterSettings/Cards/ReportDownloadFields.vue";
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { GetCurrentUser } from "@/mixins/GetCurrentUser.js";
import { GetAllUsers } from "@/mixins/Users/GetAllUsers.js";
import {
  Update_Enterprise_Details,
  CreatePincodeType,
} from "@/graphql/mutations.js";
import { GenerateS3URL } from "@/mixins/Extras/GeneratePresignedUrl.js";
import { GetAllMasterCategories } from "@/mixins/MastersSetting/GetAllMasterCategories.js";
import { GetAllOrganizationSetting } from "@/mixins/MastersSetting/GetAllOrganizationSettings.js";
import { GetAllCategoriesByMasterCategories } from "@/mixins/MastersSetting/GetAllCategoriesByMasterCategories.js";
import { GetAllOrganizationSettingsTypesInMS } from "@/mixins/MastersSetting/GetAllOrganizationSettingsTypesInMS.js";
import AddServiceDetails from "@/components/MasterSettings/Dialogs/Organizations/AddServiceDetailsDialog.vue";
import EditTerritoryDialog from "@/components/MasterSettings/Dialogs/Territories/TerritoriesEdit.vue";
import { ListPincodeTypesMixins } from "@/mixins/MastersSetting/ListPincodesTerritory.js";
import ListPincodesHistoryDialog from "@/components/MasterSettings/Dialogs/Territories/Dialogs/GetPincodesHistory.vue";

import DeleteTerritoryClassification from "@/components/MasterSettings/Dialogs/Organizations/DeleteTerritoryClassDialog.vue";
import { GetAllEscalationNotifications } from "@/mixins/MastersSetting/GetAllEscalationNotification.js";

import WebHookCard from "@/components/MasterSettings/Cards/WebHook.vue";
import PageContentHeader from "@/components/Extras/PageContentHeader.vue";
import OrganizationSettingsCategoryNav from "@/components/MasterSettings/OrganizationSettings/OrganizationSettingsCategoryNav.vue";
import OrganizationSettingsDetailDialog from "@/components/MasterSettings/OrganizationSettings/OrganizationSettingsDetailDialog.vue";
import OrganizationSettingsTicketSettingsPanel from "@/components/MasterSettings/OrganizationSettings/OrganizationSettingsTicketSettingsPanel.vue";
import OrgSettingsToggleRow from "@/components/MasterSettings/OrganizationSettings/OrgSettingsToggleRow.vue";
import OrgSettingsTableActions from "@/components/MasterSettings/OrganizationSettings/OrgSettingsTableActions.vue";
import OrgSettingsDialogField from "@/components/MasterSettings/OrganizationSettings/OrgSettingsDialogField.vue";
import OrgSettingsDialogSection from "@/components/MasterSettings/OrganizationSettings/OrgSettingsDialogSection.vue";
import {
  buildOrganizationCategories,
} from "@/constants/organizationSettingsNav.js";
import {
  onOrganizationSettingOpen,
  setOrganizationSettingActive,
  setOrganizationSettingDialogOpen,
} from "@/utils/orgSettingsLauncher.js";

export default {
  provide() {
    return { orgSettings: this };
  },
  props: {
    headless: { type: Boolean, default: false },
  },
  mixins: [
    GetAllUsers,
    GenerateS3URL,
    GetCurrentUser,
    GetAllMasterCategories,
    GetAllOrganizationSetting,
    GetAllCategoriesByMasterCategories,
    GetAllOrganizationSettingsTypesInMS,
    ListPincodeTypesMixins,
    GetAllEscalationNotifications,
  ],
  components: {
    Overlay,
    Snackbar,
    ReportDownloadFields,
    AddServiceDetails,
    EditTerritoryDialog,
    ListPincodesHistoryDialog,
    DeleteTerritoryClassification,
    WebHookCard,
    PageContentHeader,
    OrganizationSettingsCategoryNav,
    OrganizationSettingsDetailDialog,
    OrganizationSettingsTicketSettingsPanel,
    OrgSettingsToggleRow,
    OrgSettingsTableActions,
    OrgSettingsDialogField,
    OrgSettingsDialogSection,
  },
  data() {
    return {
      activeCategory: "",
      categorySearch: "",
      territoryClassDays: [
        "1 Days",
        "2 Days",
        "3 Days",
        "4 Days",
        "5 Days",
        "6 Days",
        "7 Days",
        "8 Days",
        "9 Days",
        "10 Days",
        "11 Days",
        "12 Days",
        "13 Days",
        "14 Days",
        "15 Days",
        "16 Days",
        "17 Days",
        "18 Days",
        "19 Days",
        "20 Days",
        "21 Days",
        "22 Days",
        "23 Days",
        "24 Days",
        "25 Days",
        "26 Days",
        "27 Days",
        "28 Days",
        "29 Days",
        "30 Days",
        "31 Days",
      ],
      gstSparePart: "",
      gstCallCharges: "",
      menu1: false,
      billPeriodFrom: "",
      menu2: false,
      billPeriodTo: "",
      fgrTermsCond: "",
      customerTermsCond: "",
      dealerTermsCond: "",
      enableFgrTC: false,
      url: "",
      qr_url: "",
      approver: "",
      org_address: "",
      approver_ids: [],
      module_name: "",
      feedback_url: "",
      support_type: "",
      warranty_type: "",
      product_prefix: "",
      category_prefix: "",
      days_or_hours: "Day",
      call_type_prefix: "",
      ticket_separator: "",
      account_holder: "",
      bank_name: "",
      bank_address: "",
      account_id: "",
      ifsc: "",
      tax_id: "",
      branch: "",
      pan_no: "",
      quotation_approver: "",
      quotation_mrf_approver: "",
      fgr_approver: "",
      foc_approver: "",
      quotation_approver_ids: [],
      quotation_mrf_approver_ids: [],
      fgr_approver_ids: [],
      foc_approver_ids: [],
      fgr_tech_manager_approver_ids: [],
      foc_tech_manager_approver_ids: [],
      is_otp_send_to: "BOTH",
      ticket_accept_time: "",
      location_validation: "",
      product_fleet_prefix: "",
      escalation_day: "ONE_DAY",
      distance_variation: "1.2",
      ticket_sequence_reset: "",
      organization_logo_url: "",
      product_fleet_approver: "",
      end_location_validation: "",
      product_fleet_approver_id: "",
      organization_prefix_value: "",
      terms_and_conditions: "",
      po_terms_and_conditions: "",
      po_narration: "",
      callCenterContNum: "",
      maximum_discount: 0,
      escalation_user: "",
      escalation_user_items: [],
      enable_user_select: false,
      nsm: false,
      rsm: false,
      menu: false,
      agent: false,
      manager: false,
      isLoading: false,
      renderComp: true,
      dealer_agent: false,
      loading_quotation_settings_btn: false,
      dealer_owner: false,
      partner_agent: false,
      representative: false,
      ticket_discard: false,
      enablecomponent: false,
      service_partner: false,
      enable_call_type: false,
      workflow_enabled: false,
      enable_discount: false,
      enable_payment_qr_code: false,
      enable_terms_and_conditions: false,
      enable_po_terms_and_conditions: false,
      enable_narration: false,
      enable_workflow_for_quotation: false,
      enable_workflow_for_quotation_mrf: false,
      enable_workflow_for_fgr: false,
      enable_workflow_for_foc: false,
      loading_bank_details_btn: false,
      feedback_url_enable: false,
      verify_serial_number: false,
      btn_custom_ticket_id: false,
      enable_ticket_accept: false,
      dealer_representative: false,
      enable_product_prefix: false,
      loadingTICKET_SETTINGS: false,
      enable_category_prefix: false,
      enable_ticket_sequence: false,
      partner_representative: false,
      is_clouser_type_enable: false,
      loadingOrganizationLogo: false,
      enable_ticket_separator: false,
      is_training_provided_to: false,
      loadingCATEGORY_SETTINGS: false,
      end_service_at_workplace: false,
      loading_escalation_enable: false,
      loadingATTENDANCE_SETTINGS: false,
      start_service_at_workplace: false,
      enable_edit_warranty_details: false,
      enable_edit_serial_number: false,
      loading_discard_ticket_btn: false,
      enable_organization_prefix: false,
      dealer_ticket_close_enable: false,
      enable_product_fleet_prefix: false,
      loadingDEFAULT_CUSTOMER_TYPE: false,
      enable_ticket_sequence_reset: false,
      enable_ticket_close_workflow: false,
      isLoading_distance_variation: false,
      ticket_close_after_work_start: false,
      enable_product_fleet_workflow: false,
      btn_loading_workflow_settings: false,
      escalation_notification_enable: false,
      enable_date_of_ticket_register: false,
      is_customer_category_mandatory: false,
      loadingMASTER_CATEGORY_SETTINGS: false,
      is_close_ticket_location_enable: false,
      organization_ticket_close_enable: true,
      loading_enable_ticket_accept_btn: false,
      dealer_agent_ticket_close_enable: false,
      btn_update_support_and_support_type: false,
      service_partner_ticket_close_enable: false,
      organization_RSM_ticket_close_enable: false,
      organization_NSM_ticket_close_enable: false,
      is_enabled_to_update_shceduled_service: false,
      dealer_higher_level_ticket_close_enable: false,
      dealer_representative_ticket_close_enable: false,
      service_partner_agent_ticket_close_enable: false,
      enable_to_generate_custome_based_ticket_id: false,
      organization_coordinater_ticket_close_enable: false,
      organization_higher_level_ticket_close_enable: false,
      loading_enable_location_btn_while_close_ticket: false,
      organization_representative_ticket_close_enable: false,
      service_partner_higher_level_ticket_close_enable: false,
      service_partner_representative_ticket_close_enable: false,
      payout_approver: "",
      enable_payout: false,
      payout_approver_ids: [],
      enable_payment_option: false,
      enable_disable_foc: false,
      enable_disable_cabinet: false,
      enableDisableDealerProdFleet: false,
      EditTerritoryDialog: false,
      ListPincodesHistoryDialog: false,
      deleteTerrClassDialog: false,
      files: [],
      categoryItems: [],
      GetAllUsersList: [],
      GetAllAMCTypeList: [],
      masterCategoryItems: [],
      ticket_create_sequence: [],
      ticket_create_sequence_items: [],
      product_prefix_items: [1, 2, 3],
      category_prefix_items: [1, 2, 3],
      ticket_accept_time_items: [1, 2, 3],
      product_fleet_prefix_items: [1, 2, 3],
      call_type_prefix_chars_items: [1, 2, 3],
      reopen_ticket_durationItems: [24, 48, 72],
      GetCategoriesByMasterCategoryListFilter: [],
      number_of_attachments_required_items: [1, 2, 3, 4, 5],
      ticket_accept_time_items_hours: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23,
      ],
      AutoMaticLogoutTime: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23,
      ],

      scheduled_service_dates_items: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      ticket_sequence_reset_items: [
        { text: "Day", value: "DAY" },
        { text: "Month", value: "MONTH" },
        { text: "Year", value: "YEAR" },
      ],
      ticket_separator_items: [
        { text: "-", value: "-" },
        { text: "_", value: "_" },
        { text: "/", value: "/" },
        { text: "*", value: "*" },
        { text: "^", value: "^" },
      ],
      escalation_day_items: [
        { text: "One Day", value: "ONE_DAY" },
        { text: "Two Days", value: "TWO_DAYS" },
        { text: "Three Days", value: "THREE_DAYS" },
      ],
      ticket_location_type_items: [
        { text: "EX STATION", value: "EX_STATION" },
        { text: "HEAD QUARTER", value: "HEAD_QUARTER" },
        { text: "OUT STATION", value: "OUT_STATION" },
        { text: "OTHERS", value: "OTHERS" },
      ],
      send_otp_to_items: [
        { text: "Both Customer & Technician", value: "BOTH" },
        { text: "Only Technician", value: "TECHNICIAN" },
        { text: "Only Customer", value: "CUSTOMER" },
      ],
      closure_type_items: [
        { text: "OVERCALL RESOLUTION", value: "OVERCALL_RESOLUTION" },
        { text: "CENTER VISIT", value: "CENTER_VISIT" },
      ],
      days_or_hours_items: [
        { text: "Days", value: "DAYS" },
        { text: "Hours", value: "HOURS" },
      ],
      approver_items: [
        {
          text: "REPORTING MANAGER",
          value: "REPORTING_MANAGER",
        },
        {
          text: "ADMIN",
          value: "ADMIN",
        },
        {
          text: "SPECIFIC USERS",
          value: "SPECIFIC_USERS",
        },
        {
          text: "REPORTING MANAGER AND SPECIFIC USER",
          value: "REPORTING_MANAGER_AND_SPECIFIC_USER",
        },
        {
          text: "REPORTING AND SECONDARY MANAGER",
          value: "REPORTING_AND_SECONDARY_MANAGER",
        },
      ],
      fgr_approver_items: [
        {
          text: "REPORTING MANAGER",
          value: "REPORTING_MANAGER",
        },
        {
          text: "ADMIN",
          value: "ADMIN",
        },
        {
          text: "SPECIFIC USERS",
          value: "SPECIFIC_USERS",
        },
        {
          text: "REPORTING MANAGER AND SPECIFIC USER",
          value: "REPORTING_MANAGER_AND_SPECIFIC_USER",
        },
        {
          text: "REPORTING AND SECONDARY MANAGER",
          value: "REPORTING_AND_SECONDARY_MANAGER",
        },
        {
          text: "TECHNICAL MANAGERS",
          value: "TECHNICAL_MANAGERS",
        },
        {
          text: "TECHNICAL MANAGERS AND SPECIFIC USER",
          value: "TECHNICAL_MANAGERS_AND_SPECIFIC_USER",
        },
      ],
      support_type_items: [
        { text: "Guarantee", value: "GUARANTEE" },
        { text: "Warranty", value: "WARRANTY" },
        { text: "Contract", value: "AMC" },
        { text: "Extended Warranty", value: "EXTENDED_WARRANTY" },
        { text: "No Warranty", value: "NO_WARRANTY" },
      ],
      product_repair_setting_items: [
        { text: "Product Repair", value: "product_repair" },
        { text: "Product Replace", value: "product_replace" },
        { text: "Repair & Replace", value: "both" },
      ],
      itemsssss: [
        { text: "SUN", value: "SUNDAY" },
        { text: "MON ", value: "MONDAY" },
        { text: "TUE", value: "TUESDAY" },
        { text: "WED", value: "WEDNESDAY" },
        { text: "THU", value: "THURSDAY" },
        { text: "FRI ", value: "FRIDAY" },
        { text: "SAT", value: "SATURDAY" },
      ],
      masterCategoryHeaders: [
        { title: "#", key: "sl_no" },
        { title: "Category Name", key: "master_category_name" },
        { title: "Actions", key: "Actions" },
      ],
      categoryHeaders: [
        { title: "#", key: "sl_no" },
        { title: "Master Category Name", key: "master_category_name" },
        { title: "Category Name", key: "category_name" },
        { title: "Actions", key: "Actions" },
      ],
      sort_ticket_by: [
        { text: "PREFERED VISIT DATE", value: "PREFERED_VISIT_DATE" },
        { text: "CREATION DATE", value: "CREATION_DATE" },
        { text: "MODIFIED DATE", value: "MODIFIED_DATE" },
      ],
      holidaydate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      StoreObj: {},
      SnackBarComponent: {},
      masterCategorySettings: {
        master_category_id: "",
      },
      categorySettings: {
        category_id: "",
        master_category_id: "",
      },
      auto_approval_for_own_stock_component_request: false,
      ticket_settings: {
        default_customer_type: "INDIVIDUAL",
        product_repair_or_replacement: "both",
        scheduled_service_dates: 0,
        number_of_attachments_required: 2,
        reopen_ticket: false,
        sort_ticket_by: null,
        allow_otp_proxy: false,
        active_ticket_count: null,
        enable_ticket_close: false,
        reopen_ticket_duration: null,
        enable_to_rise_ticket: false,
        enable_ticket_creation: false,
        is_attachment_mandatory: false,
        is_access_control_enable: false,
        enable_manual_territory_tagging: false,
        enable_ticket_components_request: false,
      },
      territoryObj: {},
      time_setting: {
        auto_logout_time: "",
        week_days: null,
        holidaydate: null,
      },
      quotationServiceHeader: [
        { title: "Service Name", key: "service_name" },
        { title: "Service GST", key: "service_gst" },
        { title: "Service Cost", key: "service_cost" },
        { title: "Actions", key: "actions" },
      ],
      AddServiceDetailsDialog: false,
      PrevData: [],
      addedServiceData: [],
      orgContNumber: "",
      modifiedOrgContNumber: "",
      orgEmailId: "",
      fgrTechManagers: [],
      focTechManagers: [],
      user_typeItems: [
        { text: "MANAGER", value: "MANAGER" },
        { text: "ADMIN", value: "ADMIN" },
        { text: "Service Co-Ordinator", value: "AGENT" },
        { text: "STORE MANAGER", value: "STORE_MANAGER" },
        { text: "OWNER", value: "OWNER" },
        { text: "MANAGEMENT", value: "MANAGEMENT" },
        { text: "NSM", value: "NSM" },
        { text: "RSM", value: "RSM" },
      ],
      UserType_headers: [
        {
          title: "Type",
          key: "type",
        },
        {
          title: "Actions",
          key: "actions",
        },
      ],
      duplicate_typeItems: [],
      upiId: "",
      Territory_Name: "",
      options: ["Hours", "Days"],
      selection: "Hours",
      menu: false,
      time: null,
      formattedTime: "",
      date: null,
      formattedDay: "",
      baseDate: "2025-01-01",
      startDate: "2025-01-01",
      endDate: "2025-01-31",
      TerritoryLoading: false,
      Pincodes_Items: [],
      TerritoriesHeaders: [
        {
          title: "Territory Type",
          key: "pincode_territory_type",
        },
        {
          title: "Estimated Time",
          key: "estimated_time",
        },
        {
          title: "Action",
          key: "action",
        },
      ],
      hideWebHookViewButton: false,
      ActionObj: {},
      ActionOobj: {},
      Time_Values: "",
    };
  },
  watch: {
    fgr_approver(val) {
      if (
        val === "TECHNICAL_MANAGERS_AND_SPECIFIC_USER" ||
        val === "TECHNICAL_MANAGERS"
      ) {
        this.fgrTechManagers = (this.GetAllUsersList || []).filter((item) => {
          if (item.user_type === "STORE_MANAGER") {
            return item;
          }
        });
        console.log("FGR_MANGERS_LIST", this.fgrTechManagers);
      }
    },
    foc_approver(val) {
      if (
        val === "TECHNICAL_MANAGERS_AND_SPECIFIC_USER" ||
        val === "TECHNICAL_MANAGERS"
      ) {
        this.focTechManagers = (this.GetAllUsersList || []).filter((item) => {
          if (item.user_type === "STORE_MANAGER") {
            return item;
          }
        });
      }
    },
    orgContNumber(val) {
      if (val) {
        if (val.includes(",")) {
          const separatedWithComma = val.split(",");
          this.modifiedOrgContNumber = separatedWithComma.join(" , ");
        } else {
          this.modifiedOrgContNumber = val;
        }
      }
    },
    enable_ticket_sequence(val) {
      if (val == true) {
        this.ticket_create_sequence_items.push({
          text: "Sequence",
          value: "SEQUENCE",
        });
      } else if (val == false) {
        let index_sequence = this.ticket_create_sequence_items.findIndex(
          (item) => item.value === "SEQUENCE",
        );
        this.ticket_create_sequence_items.splice(index_sequence, 1);
      }
    },
    enable_date_of_ticket_register(val) {
      if (val == true) {
        this.ticket_create_sequence_items.push({ text: "Date", value: "DATE" });
      } else if (val == false) {
        let index_date = this.ticket_create_sequence_items.findIndex(
          (item) => item.value === "DATE",
        );
        this.ticket_create_sequence_items.splice(index_date, 1);
      }
    },
    enable_call_type(val) {
      if (val == true) {
        this.ticket_create_sequence_items.push({
          text: "Call Type",
          value: "CALL_TYPE",
        });
      } else if (val == false) {
        let index_call_type = this.ticket_create_sequence_items.findIndex(
          (item) => item.value === "CALL_TYPE",
        );
        this.ticket_create_sequence_items.splice(index_call_type, 1);
      }
    },
    enable_category_prefix(val) {
      if (val == true) {
        this.ticket_create_sequence_items.push({
          text: "Category",
          value: "CATEGORY",
        });
      } else if (val == false) {
        let index_categorey = this.ticket_create_sequence_items.findIndex(
          (item) => item.value === "CATEGORY",
        );
        this.ticket_create_sequence_items.splice(index_categorey, 1);
      }
    },
    enable_product_prefix(val) {
      if (val == true) {
        this.ticket_create_sequence_items.push({
          text: "Product",
          value: "PRODUCT",
        });
      } else if (val == false) {
        let index_product = this.ticket_create_sequence_items.findIndex(
          (item) => item.value === "PRODUCT",
        );
        this.ticket_create_sequence_items.splice(index_product, 1);
      }
    },
    enable_product_fleet_prefix(val) {
      if (val == true) {
        this.ticket_create_sequence_items.push({
          text: "Product Fleet",
          value: "PRODUCT_FLEET",
        });
      } else if (val == false) {
        let index_product_fleet = this.ticket_create_sequence_items.findIndex(
          (item) => item.value === "PRODUCT_FLEET",
        );
        this.ticket_create_sequence_items.splice(index_product_fleet, 1);
      }
    },
    enable_organization_prefix(val) {
      if (val == true) {
        this.ticket_create_sequence_items.push({
          text: "Organization",
          value: "ORG",
        });
      } else if (val == false) {
        let index_org_name = this.ticket_create_sequence_items.findIndex(
          (item) => item.value === "ORG",
        );
        this.ticket_create_sequence_items.splice(index_org_name, 1);
      }
    },
    support_type(val) {
      if (val != undefined) {
        this.GetAllAMCTypeMethod("ACTIVE", val);
      }
    },
    GetAllOrganizationSettingsTypesObject(cal) {
      this.updated_items = cal.work_flow_modules;
      this.ticket_settings.scheduled_service_dates =
        cal.scheduled_service_dates;
    },
    "ticket_settings.reopen_ticket"(val) {
      if (val == false) {
        this.ticket_settings.reopen_ticket_duration = "";
      }
    },
    "ticket_settings.sort_ticket_by"(val) {
      if (val == false) {
        this.ticket_settings.sort_ticket_by = "";
      }
    },
    "categorySettings.master_category_id"(val) {
      this.GetCategoriesByMasterCategoryMethod(val);
    },
    approver(val) {
      this.approver_ids = [];
    },
  },
  computed: {
    organizationCategories() {
      try {
        const orgDetails =
          this.$store.getters.get_current_user_details?.organization_details;
        const categories = buildOrganizationCategories(this, orgDetails);
        return Array.isArray(categories) ? categories : [];
      } catch (error) {
        console.error("[OrganizationSettings] organizationCategories", error);
        return [];
      }
    },
    visibleCategories() {
      const list = this.organizationCategories;
      if (!Array.isArray(list)) return [];
      const q = (this.categorySearch || "").trim().toLowerCase();
      return list.filter((category) => {
        if (!category || category.hidden) return false;
        if (!q) return true;
        return (
          String(category.title || "")
            .toLowerCase()
            .includes(q) ||
          String(category.description || "")
            .toLowerCase()
            .includes(q)
        );
      });
    },
    activeCategoryMeta() {
      const list = this.organizationCategories;
      if (!Array.isArray(list) || !this.activeCategory) return null;
      return list.find((c) => c.id === this.activeCategory) || null;
    },
    TimeArray() {
      let Time_Value = [];
      for (let i = 1; i <= 24; i++) {
        if (i === 1) {
          Time_Value.push(`${i} Hour`);
        } else {
          Time_Value.push(`${i} Hours`);
        }
      }
      return Time_Value;
    },

    formattedFromBillDate() {
      if (!this.billPeriodFrom) return "";
      console.log("POOO", this.billPeriodFrom.split("-"));
      const [day, month, year] = this.billPeriodFrom.split("-");
      return `${day}-${month}-${year}`;
    },

    formattedToBillDate() {
      if (!this.billPeriodTo) return "";
      const [day, month, year] = this.billPeriodTo.split("-");
      return `${day}-${month}-${year}`;
    },

    ticketWorkflowColumns() {
      return [
        {
          id: "organization",
          title: "Organization Higher Level",
          icon: "mdi-domain",
          accent: "violet",
          parentKey: "organization_ticket_close_enable",
          roles: [
            {
              label: "Representative",
              key: "organization_representative_ticket_close_enable",
            },
            {
              label: "RSM",
              key: "organization_RSM_ticket_close_enable",
            },
            {
              label: "NSM",
              key: "organization_NSM_ticket_close_enable",
            },
            {
              label: "Service Co-Ordinator",
              key: "organization_coordinater_ticket_close_enable",
            },
            {
              label: "Admin Level",
              key: "organization_higher_level_ticket_close_enable",
            },
          ],
        },
        {
          id: "service-partner",
          title: "Service Partner Higher Level",
          icon: "mdi-handshake-outline",
          accent: "teal",
          parentKey: "service_partner_ticket_close_enable",
          roles: [
            {
              label: "Representative",
              key: "service_partner_representative_ticket_close_enable",
            },
            {
              label: "Service Co-Ordinator",
              key: "service_partner_agent_ticket_close_enable",
            },
            {
              label: "Admin Level",
              key: "service_partner_higher_level_ticket_close_enable",
            },
          ],
        },
        {
          id: "dealer",
          title: "Dealer Higher Level",
          icon: "mdi-store-outline",
          accent: "amber",
          parentKey: "dealer_ticket_close_enable",
          roles: [
            {
              label: "Representative",
              key: "dealer_representative_ticket_close_enable",
            },
            {
              label: "Service Co-Ordinator",
              key: "dealer_agent_ticket_close_enable",
            },
            {
              label: "Admin Level",
              key: "dealer_higher_level_ticket_close_enable",
            },
          ],
        },
      ];
    },
  },
  async mounted() {
    this._unsubOrgSettingsOpen = onOrganizationSettingOpen((categoryId) => {
      this.openCategory(categoryId);
    });

    const orgDetails =
      this.$store.getters.get_current_user_details?.organization_details;
    if (!orgDetails) {
      return;
    }

    await this.GetAllEscalationNotificationMethod("ACTIVE");

    this.escalation_user_items = (
      this.GetAllEscalationNotificationList || []
    ).flatMap((item) => (item.users_to_notify ? item.users_to_notify : []));
    // this.escalation_user_items = items.map(item => item.replace(/,|"/g, "").trim());
    await this.GetAllUsersMethod(undefined, "ACTIVE");
    this.GetAllOrganizationSettingsTypesMethod(this.status);
    this.GetCategoriesByMasterCategoryMethod(this.status);
    this.GetAllMasterCategoriesMethod(this.status);
    await this.ListPincodeTypes();
    this.feedback_url_enable =
      this.$store.getters.get_current_user_details.organization_details
        .feedback_url_enable != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .feedback_url_enable
        : false;
    this.feedback_url =
      this.$store.getters.get_current_user_details.organization_details.feedback_url;
    this.distance_variation =
      this.$store.getters.get_current_user_details.organization_details.distance_variation;
    this.is_close_ticket_location_enable =
      this.$store.getters.get_current_user_details.organization_details
        .is_close_ticket_location_enable != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .is_close_ticket_location_enable
        : false;
    this.is_clouser_type_enable =
      this.$store.getters.get_current_user_details.organization_details
        .is_clouser_type_enable != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .is_clouser_type_enable
        : false;
    this.is_otp_send_to =
      this.$store.getters.get_current_user_details.organization_details
        .is_otp_send_to != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .is_otp_send_to
        : "BOTH";
    this.is_training_provided_to =
      this.$store.getters.get_current_user_details.organization_details.is_training_provided_to;
    this.escalation_notification_enable =
      this.$store.getters.get_current_user_details.organization_details.escalation_notification_enable;
    this.escalation_day =
      this.$store.getters.get_current_user_details.organization_details.escalation_day;
    try {
      this.enable_user_select =
        this.$store.getters.get_current_user_details.organization_details
          .is_enabled_to_share_escalation_notification_to_user || false;
      this.escalation_user =
        this.$store.getters.get_current_user_details.organization_details
          .escalation_notified_selected_users || "";
    } catch (error) {}
    this.ticket_discard =
      this.$store.getters.get_current_user_details.organization_details.ticket_discard;
    this.enable_ticket_accept =
      this.$store.getters.get_current_user_details.organization_details
        .enable_ticket_accept != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_ticket_accept
        : false;
    this.enable_ticket_close_workflow =
      this.$store.getters.get_current_user_details.organization_details.enable_ticket_close_workflow;
    this.dealer_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.dealer_ticket_close_enable;
    this.dealer_representative_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.dealer_representative_ticket_close_enable;
    this.service_partner_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.service_partner_ticket_close_enable;
    this.service_partner_representative_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.service_partner_representative_ticket_close_enable;
    this.service_partner_agent_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.service_partner_agent_ticket_close_enable;
    this.service_partner_higher_level_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.service_partner_higher_level_ticket_close_enable;
    this.organization_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.organization_ticket_close_enable;
    this.organization_representative_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.organization_representative_ticket_close_enable;
    this.organization_RSM_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.organization_RSM_ticket_close_enable;
    this.organization_NSM_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.organization_NSM_ticket_close_enable;
    this.organization_coordinater_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.organization_coordinater_ticket_close_enable;
    this.organization_higher_level_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.organization_higher_level_ticket_close_enable;
    this.dealer_higher_level_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.dealer_higher_level_ticket_close_enable;
    this.dealer_agent_ticket_close_enable =
      this.$store.getters.get_current_user_details.organization_details.dealer_agent_ticket_close_enable;
    this.enable_edit_serial_number =
      this.$store.getters.get_current_user_details.organization_details
        .enable_edit_serial_number != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_edit_serial_number
        : false;
    this.enable_edit_warranty_details =
      this.$store.getters.get_current_user_details.organization_details
        .enable_edit_warranty_details != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_edit_warranty_details
        : false;
    this.callCenterContNum =
      this.$store.getters.get_current_user_details.organization_details.call_center_contact_number;
    this.start_service_at_workplace =
      this.$store.getters.get_current_user_details.organization_details
        .start_service_at_workplace != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .start_service_at_workplace
        : false;
    this.end_service_at_workplace =
      this.$store.getters.get_current_user_details.organization_details
        .end_service_at_workplace != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .end_service_at_workplace
        : false;
    this.ticket_close_after_work_start =
      this.$store.getters.get_current_user_details.organization_details.ticket_close_after_work_start;
    this.location_validation =
      this.$store.getters.get_current_user_details.organization_details.location_validation;
    this.end_location_validation =
      this.$store.getters.get_current_user_details.organization_details.end_location_validation;
    this.ticket_accept_time = this.getTicketAcceptTime();
    this.is_enabled_to_update_shceduled_service =
      this.$store.getters.get_current_user_details.organization_details.is_enabled_to_update_shceduled_service;
    this.enable_to_generate_custome_based_ticket_id =
      this.$store.getters.get_current_user_details.organization_details
        .enable_to_generate_custome_based_ticket_id != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_to_generate_custome_based_ticket_id
        : undefined;
    this.enable_organization_prefix =
      this.$store.getters.get_current_user_details.organization_details
        .enable_organization_prefix != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_organization_prefix
        : undefined;
    this.enable_call_type =
      this.$store.getters.get_current_user_details.organization_details
        .enable_call_type != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_call_type
        : undefined;
    this.enable_category_prefix =
      this.$store.getters.get_current_user_details.organization_details
        .enable_category_prefix != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_category_prefix
        : undefined;
    this.enable_product_prefix =
      this.$store.getters.get_current_user_details.organization_details
        .enable_product_prefix != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_product_prefix
        : undefined;
    this.enable_product_fleet_prefix =
      this.$store.getters.get_current_user_details.organization_details
        .enable_product_fleet_prefix != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_product_fleet_prefix
        : undefined;
    this.enable_date_of_ticket_register =
      this.$store.getters.get_current_user_details.organization_details
        .enable_date_of_ticket_register != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_date_of_ticket_register
        : undefined;
    this.enable_ticket_sequence_reset =
      this.$store.getters.get_current_user_details.organization_details
        .enable_ticket_sequence_reset != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_ticket_sequence_reset
        : undefined;
    this.enable_ticket_sequence =
      this.$store.getters.get_current_user_details.organization_details
        .enable_ticket_sequence != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_ticket_sequence
        : undefined;
    this.ticket_sequence_reset =
      this.$store.getters.get_current_user_details.organization_details
        .ticket_sequence_reset != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .ticket_sequence_reset
        : undefined;
    this.ticket_separator =
      this.$store.getters.get_current_user_details.organization_details
        .ticket_separator != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .ticket_separator
        : undefined;
    this.ticket_create_sequence =
      orgDetails.ticket_create_sequence != undefined
        ? orgDetails.ticket_create_sequence
        : [];
    this.enable_ticket_separator =
      this.$store.getters.get_current_user_details.organization_details
        .enable_ticket_separator != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_ticket_separator
        : undefined;
    this.call_type_prefix =
      this.$store.getters.get_current_user_details.organization_details
        .call_type_prefix != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .call_type_prefix
        : undefined;
    this.category_prefix =
      this.$store.getters.get_current_user_details.organization_details
        .category_prefix != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .category_prefix
        : undefined;
    this.product_prefix =
      this.$store.getters.get_current_user_details.organization_details
        .product_prefix != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .product_prefix
        : undefined;
    this.product_fleet_prefix =
      this.$store.getters.get_current_user_details.organization_details
        .product_fleet_prefix != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .product_fleet_prefix
        : undefined;
    this.organization_prefix_value =
      this.$store.getters.get_current_user_details.organization_details
        .organization_prefix_value != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .organization_prefix_value
        : undefined;
    this.verify_serial_number =
      this.$store.getters.get_current_user_details.organization_details
        .verify_serial_number != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .verify_serial_number
        : false;
    this.is_customer_category_mandatory =
      this.$store.getters.get_current_user_details.organization_details
        .is_customer_category_mandatory != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .is_customer_category_mandatory
        : false;
    this.enable_payment_option =
      this.$store.getters.get_current_user_details.organization_details
        .enable_payment_details_for_tickets != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_payment_details_for_tickets
        : false;
    this.enable_disable_foc =
      this.$store.getters.get_current_user_details.organization_details
        .enable_foc_for_ticket != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_foc_for_ticket
        : false;
    this.enable_disable_cabinet =
      this.$store.getters.get_current_user_details.organization_details
        .enable_cabinet_for_tech != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_cabinet_for_tech
        : false;
    this.enableDisableDealerProdFleet =
      this.$store.getters.get_current_user_details.organization_details
        .disable_productfleet_for_dealer != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .disable_productfleet_for_dealer
        : false;
    this.support_type =
      this.$store.getters.get_current_user_details.organization_details.support_type;
    this.warranty_type =
      this.$store.getters.get_current_user_details.organization_details.warranty_type;
    this.enable_terms_and_conditions =
      this.$store.getters.get_current_user_details.organization_details
        .enable_terms_and_conditions != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_terms_and_conditions
        : false;

    this.enable_po_terms_and_conditions =
      this.$store.getters.get_current_user_details.organization_details
        .enable_terms_and_conditions_for_fgr != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_terms_and_conditions_for_fgr
        : false;

    this.enableFgrTC =
      this.$store.getters.get_current_user_details.organization_details
        .enable_terms_and_conditions_for_fgr || false;

    this.customerTermsCond =
      this.$store.getters.get_current_user_details.organization_details
        .customer_terms_and_conditions || undefined;
    this.dealerTermsCond =
      this.$store.getters.get_current_user_details.organization_details
        .dealer_terms_and_conditions || undefined;
    this.fgrTermsCond =
      this.$store.getters.get_current_user_details.organization_details
        .product_replacement_terms_and_conditions || undefined;

    this.terms_and_conditions =
      this.$store.getters.get_current_user_details.organization_details
        .terms_and_conditions != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .terms_and_conditions
        : false;

    this.po_terms_and_conditions =
      this.$store.getters.get_current_user_details.organization_details
        .po_terms_and_conditions != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .po_terms_and_conditions
        : false;

    this.po_narration =
      this.$store.getters.get_current_user_details.organization_details
        .po_narration != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .po_narration
        : false;
    this.enable_discount =
      this.$store.getters.get_current_user_details.organization_details
        .enable_discount != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .enable_discount
        : false;
    this.maximum_discount =
      this.$store.getters.get_current_user_details.organization_details
        .maximum_discount != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .maximum_discount
        : 0;
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[0].approver != undefined
      ) {
        this.approver =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[0].approver;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[1].approver != undefined
      ) {
        this.product_fleet_approver =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[1].approver;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[0].approver_ids != undefined &&
        typeof this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[0].approver_ids != "string" &&
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[0].approver_ids.length != 0
      ) {
        this.approver_ids = this.mountApproverIdsMethod(
          this.$store.getters.get_current_user_details.organization_details
            .workflow_settings[0].approver_ids,
        );
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[1].approver_id != undefined
      ) {
        this.product_fleet_approver_id =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[1].approver_id;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[0].workflow_enabled != undefined
      ) {
        this.workflow_enabled =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[0].workflow_enabled;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[1].workflow_enabled != undefined
      ) {
        this.enable_product_fleet_workflow =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[1].workflow_enabled;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[0].module_name != undefined
      ) {
        this.module_name =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[0].module_name;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[2].workflow_enabled != undefined
      ) {
        this.enable_workflow_for_quotation =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[2].workflow_enabled;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[3].workflow_enabled != undefined
      ) {
        this.enable_workflow_for_quotation_mrf =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[3].workflow_enabled;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[4].workflow_enabled != undefined
      ) {
        this.enable_workflow_for_fgr =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[4].workflow_enabled;
      }
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[5].workflow_enabled != undefined
      ) {
        this.enable_workflow_for_foc =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[5].workflow_enabled;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[2].approver != undefined
      ) {
        this.quotation_approver =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[2].approver;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[3].approver != undefined
      ) {
        this.quotation_mrf_approver =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[3].approver;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[4].approver != undefined
      ) {
        this.fgr_approver =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[4].approver;
        this.fgr_tech_manager_approver_ids = this.callFgrTechManagerApproverId(
          this.$store.getters.get_current_user_details.organization_details
            .workflow_settings[4].technical_manager_ids,
        );
        //   this.$store.getters.get_current_user_details.organization_details.workflow_settings[4].technical_manager_ids;
        // console.log(
        //   "CHECK_FGR_IDS",
        //   this.$store.getters.get_current_user_details.organization_details
        //     .workflow_settings[4],
        // );
      }
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[5].approver != undefined
      ) {
        this.foc_approver =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[5].approver;
        this.foc_tech_manager_approver_ids =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[5].technical_manager_ids;
      }
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[6].approver != undefined
      ) {
        this.enable_payout =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[6].workflow_enabled;
        this.payout_approver =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[6].approver;
        this.payout_approver_ids =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[6].approver_ids;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[2].approver_ids != undefined &&
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[2].approver_ids.length != 0
      ) {
        this.quotation_approver_ids =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[2].approver_ids;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[3].approver_ids != undefined &&
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[3].approver_ids.length != 0
      ) {
        this.quotation_mrf_approver_ids =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[3].approver_ids;
      }
    }
    if (
      this.$store.getters.get_current_user_details.organization_details
        .workflow_settings != undefined
    ) {
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[4].approver_ids != undefined &&
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[4].approver_ids.length != 0
      ) {
        this.fgr_approver_ids =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[4].approver_ids;
      }
      if (
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[5].approver_ids != undefined &&
        this.$store.getters.get_current_user_details.organization_details
          .workflow_settings[5].approver_ids.length != 0
      ) {
        this.foc_approver_ids =
          this.$store.getters.get_current_user_details.organization_details.workflow_settings[5].approver_ids;
      }
    }
    this.auto_approval_for_own_stock_component_request =
      this.$store.getters.get_current_user_details.organization_details
        .auto_approval_for_own_stock_component_request != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .auto_approval_for_own_stock_component_request
        : false;
    this.days_or_hours =
      this.$store.getters.get_current_user_details.organization_details
        .ticket_accept_time != undefined
        ? this.$store.getters.get_current_user_details.organization_details.ticket_accept_time.includes(
            "DAYS",
          )
          ? "DAYS"
          : "HOURS"
        : "";
    this.account_holder =
      this.$store.getters.get_current_user_details.organization_details
        .bank_details != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .bank_details.account_holder != undefined
          ? this.$store.getters.get_current_user_details.organization_details
              .bank_details.account_holder
          : undefined
        : undefined;
    this.bank_name =
      this.$store.getters.get_current_user_details.organization_details
        .bank_details != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .bank_details.bank_name != undefined
          ? this.$store.getters.get_current_user_details.organization_details
              .bank_details.bank_name
          : undefined
        : undefined;
    this.bank_address =
      this.$store.getters.get_current_user_details.organization_details
        .bank_details != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .bank_details.bank_address != undefined
          ? this.$store.getters.get_current_user_details.organization_details
              .bank_details.bank_address
          : undefined
        : undefined;
    this.account_id =
      this.$store.getters.get_current_user_details.organization_details
        .bank_details != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .bank_details.account_id != undefined
          ? this.$store.getters.get_current_user_details.organization_details
              .bank_details.account_id
          : undefined
        : undefined;
    this.ifsc =
      this.$store.getters.get_current_user_details.organization_details
        .bank_details != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .bank_details.ifsc != undefined
          ? this.$store.getters.get_current_user_details.organization_details
              .bank_details.ifsc
          : undefined
        : undefined;
    this.branch =
      this.$store.getters.get_current_user_details.organization_details
        .bank_details != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .bank_details.branch != undefined
          ? this.$store.getters.get_current_user_details.organization_details
              .bank_details.branch
          : undefined
        : undefined;
    this.tax_id =
      this.$store.getters.get_current_user_details.organization_details
        .bank_details != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .bank_details.tax_id != undefined
          ? this.$store.getters.get_current_user_details.organization_details
              .bank_details.tax_id
          : undefined
        : undefined;
    this.pan_no =
      this.$store.getters.get_current_user_details.organization_details
        .bank_details != undefined
        ? this.$store.getters.get_current_user_details.organization_details
            .bank_details.pan_no != undefined
          ? this.$store.getters.get_current_user_details.organization_details
              .bank_details.pan_no
          : undefined
        : undefined;
    this.upiId =
      this.$store.getters.get_current_user_details.organization_details.bank_details.upi_id;
    this.billPeriodFrom =
      this.$store.getters.get_current_user_details.organization_details.bill_period_from_date;
    this.billPeriodTo =
      this.$store.getters.get_current_user_details.organization_details.bill_period_to_date;
    this.gstCallCharges =
      this.$store.getters.get_current_user_details.organization_details.gst_call_charges;
    this.gstSparePart =
      this.$store.getters.get_current_user_details.organization_details.gst_spare_part;
    const matchedElements = [];
    const rightsOfRfsRaw = orgDetails.rights_of_rfs;
    const rightsOfRfs = Array.isArray(rightsOfRfsRaw) ? rightsOfRfsRaw : [];
    this.duplicate_typeItems = rightsOfRfs
        .map((item) => {
          const matchedElement = (this.user_typeItems || []).find(
            (element) => element.value == item,
          );
          if (matchedElement) {
            matchedElements.push(matchedElement.value);
          }
          return matchedElement;
        })
        .filter((el) => el !== undefined);
    this.user_typeItems = (this.user_typeItems || []).filter(
      (element) => !matchedElements.includes(element.value),
    );
  },
  beforeUnmount() {
    this._unsubOrgSettingsOpen?.();
    if (this.headless && this.activeCategory) {
      setOrganizationSettingDialogOpen(false);
    }
  },
  methods: {
    openCategory(id) {
      this.activeCategory = id;
      setOrganizationSettingActive(id);
      if (this.headless) {
        setOrganizationSettingDialogOpen(true);
      }
    },
    closeCategory() {
      this.activeCategory = "";
      if (this.headless) {
        setOrganizationSettingDialogOpen(false);
      }
    },
    twfParentActive(parentKey) {
      return !!this[parentKey];
    },
    toggleTwfParent(parentKey) {
      this[parentKey] = !this[parentKey];
    },
    isTwfRoleActive(roleKey) {
      return !!this[roleKey];
    },
    toggleTwfRole(roleKey) {
      this[roleKey] = !this[roleKey];
    },
    isAllTwfRolesSelected(column) {
      if (!this.twfParentActive(column.parentKey)) return false;
      return column.roles.every((role) => this.isTwfRoleActive(role.key));
    },
    toggleAllTwfRoles(column) {
      const selectAll = !this.isAllTwfRolesSelected(column);
      column.roles.forEach((role) => {
        this[role.key] = selectAll;
      });
    },
    twfAllToggleLabel(column) {
      return this.isAllTwfRolesSelected(column) ? "Clear all" : "Select all";
    },
    saveDate1() {
      this.$refs.menu1.save(this.billPeriodFrom);
      this.menu1 = false;
    },
    mountApproverIdsMethod(ids) {
      setTimeout(() => {
        this.approver_ids = (this.GetAllUsersList || []).filter((user) =>
          ids.includes(user.user_id),
        );
        console.log("APPROVER_IDS", this.approver_ids);
      }, 2000);
    },
    callFgrTechManagerApproverId(idArray) {
      setTimeout(() => {
        this.fgr_tech_manager_approver_ids = idArray.filter((id) =>
          this.fgrTechManagers.some((manager) => manager.user_id === id),
        );
      }, 2000);
    },

    formatedBillPeriodFrom(val) {
      this.menu1 = false;
      if (val) {
        const d = new Date(val);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        this.billPeriodFrom = `${day}-${month}-${year}`;
      }
    },
    formatedBillPeriodTo(val) {
      this.menu2 = false;
      if (val) {
        const d = new Date(val);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        this.billPeriodTo = `${day}-${month}-${year}`;
      }
    },

    saveDate2() {
      this.$refs.menu2.save(this.billPeriodTo);
      this.menu2 = false;
    },
    reportsFieldsEmit(Status_Message, status) {
      this.renderComp = false;
      this.$nextTick(() => {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: status == "SUCCESS" ? "green" : "red",
          Top: true,
          SnackbarText: Status_Message,
        };
        this.renderComp = true;
      });
    },

    AddServiceDetailsDialogMethod(item, index, action) {
      this.AddServiceDetailsDialog = true;
      this.StoreObj = item;
      this.StoreObj.action = action;
      this.StoreObj.item_index = index;
      this.PrevData =
        this.$store.getters.get_current_user_details.organization_details
          .quotation_service_charges == undefined
          ? []
          : this.$store.getters.get_current_user_details.organization_details
              .quotation_service_charges;
    },
    callmethodUppercase(organization_prefix_value) {
      this.organization_prefix_value = organization_prefix_value.toUpperCase();
    },
    copyFormUrlCustomer() {
      const textToCopy =
        `https://webform.servicewrk.com/$${this.$store.getters.get_current_user_details.organization_details.organization_name}`.includes(
          " ",
        )
          ? `https://webform.servicewrk.com/$${this.$store.getters.get_current_user_details.organization_details.organization_name}`.replaceAll(
              " ",
              "_",
            )
          : `https://webform.servicewrk.com/$${this.$store.getters.get_current_user_details.organization_details.organization_name}`;
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.renderComp = false;
      this.$nextTick(() => {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          Top: true,
          SnackbarText: "Customer Web form url copied !!!",
        };
        this.renderComp = true;
      });
    },
    async saveOrgLogo() {
      if (this.url != undefined && this.url != "" && this.url != null) {
        this.uploadMediaToS3();
      } else {
        this.saveSettingsMethod("ORGANIZATION_LOGO");
      }
    },
    async saveQuotationDetails() {
      if (
        this.qr_url != undefined &&
        this.qr_url != null &&
        this.qr_url != ""
      ) {
        this.uploadQrCodeToS3();
      } else {
        this.saveSettingsMethod("QUOTATION_DETAILS");
      }
    },
    checkImagePresent() {
      if (this.url == null || this.url == "" || this.url == undefined) {
        this.handleUpload();
      }
    },
    uploadQrCode() {
      if (
        this.qr_url == null ||
        this.qr_url == "" ||
        this.qr_url == undefined
      ) {
        this.handleQrUpload();
      }
    },
    handleUpload() {
      this.$refs["excel-upload-input"].click();
    },
    handleQrUpload() {
      this.$refs["qr-upload-input"].click();
    },
    upload_qr_code(e) {
      this.selectedQrFile = e.target.files[0];
      this.qr_url = URL.createObjectURL(this.selectedQrFile);
    },
    handleClick(e) {
      this.selectedFile = e.target.files[0];
      this.url = URL.createObjectURL(this.selectedFile);
    },
    getTicketAcceptTime() {
      let ticketAcceptTime =
        this.$store.getters.get_current_user_details.organization_details
          .ticket_accept_time;
      if (ticketAcceptTime != undefined) {
        let SplittedWord = ticketAcceptTime.split("_");
        return SplittedWord[1];
      }
    },
    async uploadQrCodeToS3() {
      this.loading_quotation_settings_btn = true;
      if (this.selectedQrFile != undefined && this.selectedQrFile != "") {
        let result = await this.GenerateS3URLMethods(
          `${
            this.$store.getters.get_current_user_details.organization_id
          }/QR_CODE/${new Date().getTime()}_${this.selectedQrFile.name}`,
          this.selectedQrFile,
        );
        this.qr_code = result.profile_pic_url;
      } else {
        this.qr_code = this.qr_url;
      }
      this.saveSettingsMethod("QUOTATION_DETAILS");
    },
    async uploadMediaToS3() {
      this.loadingOrganizationLogo = true;
      if (this.selectedFile != undefined) {
        let result = await this.GenerateS3URLMethods(
          `${
            this.$store.getters.get_current_user_details.organization_id
          }/PROFILE_PIC/${new Date().getTime()}_${this.selectedFile.name}`,
          this.selectedFile,
        );
        this.org_logo = result.profile_pic_url;
      } else {
        this.org_logo = this.url;
      }
      this.saveSettingsMethod("ORGANIZATION_LOGO");
    },
    async validateMethod(action) {
      switch (action) {
        case "TICKET_SETTINGS":
          if (
            this.ticket_settings.active_ticket_count != undefined &&
            this.ticket_settings.active_ticket_count != null &&
            this.ticket_settings.active_ticket_count != ""
          ) {
            if (this.ticket_settings.reopen_ticket == true) {
              if (
                this.ticket_settings.reopen_ticket_duration != undefined &&
                this.ticket_settings.reopen_ticket_duration != null &&
                this.ticket_settings.reopen_ticket_duration != ""
              ) {
                this.saveSettingsMethod(action, this.ticket_settings);
              } else {
                this.renderComp = false;
                this.$nextTick(() => {
                  this.SnackBarComponent = {
                    SnackbarVmodel: true,
                    SnackbarColor: "red",
                    Top: true,
                    SnackbarText: "Please Select Reopen Ticket Duration",
                  };
                  this.renderComp = true;
                });
              }
            }
          } else {
            this.renderComp = false;
            this.$nextTick(() => {
              this.SnackBarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "red",
                Top: true,
                SnackbarText: "Please Add Ticket Count",
              };
              this.renderComp = true;
            });
          }
          break;
        case "WORK_FLOW":
          const isValid1 = await this.$refs.form_workflow_settings.validate();
          if (isValid1.valid) {
            this.saveSettingsMethod(action, this.work_flow);
          } else {
            this.renderComp = false;
            this.$nextTick(() => {
              this.SnackBarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "red",
                Top: true,
                SnackbarText: "Please Select Mandatory Fields..!",
              };
              this.renderComp = true;
            });
          }
          break;
        case "UPDATE_CUSTOME_BASED_TICKET_ID":
          if (
            this.ticket_create_sequence != [] &&
            this.ticket_create_sequence != undefined
          ) {
            if (
              this.enable_organization_prefix == false ||
              this.enable_organization_prefix == undefined
            ) {
              if (this.ticket_create_sequence.includes("ORG")) {
                const sequenceListArray = this.ticket_create_sequence;
                const stringToRemove = "ORG";
                const newArray = sequenceListArray.filter(
                  (item) => item != stringToRemove,
                );
                this.ticket_create_sequence = newArray;
              }
            }
            if (
              this.enable_call_type == false ||
              this.enable_call_type == undefined
            ) {
              if (this.ticket_create_sequence.includes("CALL_TYPE")) {
                const sequenceListArray = this.ticket_create_sequence;
                const stringToRemove = "CALL_TYPE";
                const newArray = sequenceListArray.filter(
                  (item) => item != stringToRemove,
                );
                this.ticket_create_sequence = newArray;
              }
            }
            if (
              this.enable_category_prefix == false ||
              this.enable_category_prefix == undefined
            ) {
              if (this.ticket_create_sequence.includes("CATEGORY")) {
                const sequenceListArray = this.ticket_create_sequence;
                const stringToRemove = "CATEGORY";
                const newArray = sequenceListArray.filter(
                  (item) => item != stringToRemove,
                );
                this.ticket_create_sequence = newArray;
              }
            }
            if (
              this.enable_product_fleet_prefix == false ||
              this.enable_product_fleet_prefix == undefined
            ) {
              if (this.ticket_create_sequence.includes("PRODUCT_FLEET")) {
                const sequenceListArray = this.ticket_create_sequence;
                const stringToRemove = "PRODUCT_FLEET";
                const newArray = sequenceListArray.filter(
                  (item) => item != stringToRemove,
                );
                this.ticket_create_sequence = newArray;
              }
            }
            if (
              this.enable_product_prefix == false ||
              this.enable_product_prefix == undefined
            ) {
              if (this.ticket_create_sequence.includes("PRODUCT")) {
                const sequenceListArray = this.ticket_create_sequence;
                const stringToRemove = "PRODUCT";
                const newArray = sequenceListArray.filter(
                  (item) => item != stringToRemove,
                );
                this.ticket_create_sequence = newArray;
              }
            }
            if (
              this.enable_date_of_ticket_register == false ||
              this.enable_date_of_ticket_register == undefined
            ) {
              if (this.ticket_create_sequence.includes("DATE")) {
                const sequenceListArray = this.ticket_create_sequence;
                const stringToRemove = "DATE";
                const newArray = sequenceListArray.filter(
                  (item) => item != stringToRemove,
                );
                this.ticket_create_sequence = newArray;
              }
            }
            if (
              this.enable_ticket_sequence == false ||
              this.enable_ticket_sequence == undefined
            ) {
              if (this.ticket_create_sequence.includes("SEQUENCE")) {
                const sequenceListArray = this.ticket_create_sequence;
                const stringToRemove = "SEQUENCE";
                const newArray = sequenceListArray.filter(
                  (item) => item != stringToRemove,
                );
                this.ticket_create_sequence = newArray;
              }
            }
          }
          this.saveSettingsMethod(action, this.update_custome_based_ticket_id);
          break;
        case "UPDATE_SUPPORT_AND_SUPPORT_TYPE":
          this.saveSettingsMethod(action, this.update_support_and_support_type);
          break;
        case "FEEDBACK_URL":
          this.saveSettingsMethod(action, this.feedback_url);
          break;
        case "DISTANCE_VARIATION":
          this.saveSettingsMethod(action, this.distance_variation);
          break;
        case "ORGANIZATION_LOGO":
          this.saveSettingsMethod(action, this.masterCategoryItems);
          break;
        case "MASTER_CATEGORY_SETTINGS":
          this.saveSettingsMethod(action, this.masterCategoryItems);
          break;
        case "CATEGORY_SETTINGS":
          this.saveSettingsMethod(action, this.categoryItems);
          break;
        case "ATTENDANCE_SETTINGS":
          this.saveSettingsMethod(action, this.time_setting);
          break;
        case "CLOSE_LOCATION_ENABLE":
          this.saveSettingsMethod(action, this.is_close_ticket_location_enable);
          break;
        case "TICKET_WORKFLOW":
          if (this.enable_ticket_close_workflow == true) {
            if (
              this.service_partner_ticket_close_enable == true ||
              this.organization_ticket_close_enable == true ||
              this.dealer_ticket_close_enable == true
            ) {
              this.saveSettingsMethod(action, this.enable_ticket_accept);
            } else {
              this.renderComp = false;
              this.$nextTick(() => {
                this.SnackBarComponent = {
                  SnackbarVmodel: true,
                  SnackbarColor: "red",
                  Top: true,
                  SnackbarText: "Please Select Atleast one level",
                };
                this.renderComp = true;
              });
            }
          } else {
            this.saveSettingsMethod(action, this.enable_ticket_accept);
          }
          break;
        case "ESCALATION":
          this.saveSettingsMethod(action, this.escalation_day);
          break;
        case "TICKET_DISCARD":
          this.saveSettingsMethod(action, this.ticket_discard);
          break;
        case "BANK_DETAILS":
          const isValid2 = await this.$refs.bank_details_form.validate();
          if (isValid2.valid) {
            this.saveSettingsMethod(action);
          } else {
            this.renderComp = false;
            this.$nextTick(() => {
              this.SnackBarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "red",
                Top: true,
                SnackbarText: "Fill Mandatory Details *",
              };
              this.renderComp = true;
            });
          }
          break;
        case "QUOTATION_DETAILS":
          const isValid3 = await this.$refs.quotation_settings_form.validate();
          if (isValid3.valid) {
            this.saveSettingsMethod(action);
          } else {
            this.renderComp = false;
            this.$nextTick(() => {
              this.SnackBarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "red",
                Top: true,
                SnackbarText: "Fill Mandatory Details *",
              };
              this.renderComp = true;
            });
          }
          break;
        case "PAYOUT":
          if (
            // this.gstCallCharges &&
            // this.gstSparePart &&
            this.formattedToBillDate &&
            this.formattedFromBillDate
          ) {
            this.saveSettingsMethod(action);
          } else {
            this.renderComp = false;
            this.$nextTick(() => {
              this.SnackBarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "red",
                Top: true,
                SnackbarText: "Fill Mandatory Details*",
              };
              this.renderComp = true;
            });
          }
          break;
      }
    },
    async validateCMethod() {
      const isValid4 = await this.$refs.formC.validate();
      if (isValid4.valid) {
        if (
          this.categoryItems.filter(
            (item) => item.category_id == this.categorySettings.category_id,
          ).length == 0
        ) {
          let categoryObject = {
            master_category_id: this.categorySettings.master_category_id,
            master_category_name: this.masterCategoryItems.filter(
              (item) =>
                item.master_category_id ==
                this.categorySettings.master_category_id,
            )[0].master_category_name,
            category_id: this.categorySettings.category_id,
            category_name: this.GetCategoriesByMasterCategoryList.filter(
              (item) => item.category_id == this.categorySettings.category_id,
            )[0].category_name,
          };
          this.categoryItems.push(categoryObject);
        } else {
          this.renderComp = false;
          this.$nextTick(() => {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              Top: true,
              SnackbarText: "Category Name Already Exists",
            };
            this.renderComp = true;
          });
        }
      } else {
        this.renderComp = false;
        this.$nextTick(() => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Please Select Master Category",
          };
          this.renderComp = true;
        });
      }
    },
    async saveSettingsMethod(action, settings) {
      try {
        var inputParams = {
          updater_user_id: this.$store.getters.get_current_user_details.user_id,
          organization_id:
            this.$store.getters.get_current_user_details.organization_id,
          setting_action: action,
        };
        switch (action) {
          case "UPDATE_CUSTOME_BASED_TICKET_ID":
            if (
              this.ticket_create_sequence != [] &&
              this.ticket_create_sequence.length != 0
            ) {
              this.btn_custom_ticket_id = true;
              inputParams.enable_to_generate_custome_based_ticket_id =
                this.enable_to_generate_custome_based_ticket_id;
              inputParams.enable_organization_prefix =
                this.enable_organization_prefix != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.enable_organization_prefix
                  : undefined;
              inputParams.organization_prefix_value =
                this.organization_prefix_value != "" &&
                this.organization_prefix_value != null &&
                this.organization_prefix_value != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.organization_prefix_value
                  : undefined;
              inputParams.enable_call_type =
                this.enable_call_type != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.enable_call_type
                  : undefined;
              inputParams.enable_category_prefix =
                this.enable_category_prefix != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.enable_category_prefix
                  : undefined;
              inputParams.enable_product_prefix =
                this.enable_product_prefix != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.enable_product_prefix
                  : undefined;
              inputParams.enable_product_fleet_prefix =
                this.enable_product_fleet_prefix != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.enable_product_fleet_prefix
                  : undefined;
              inputParams.call_type_prefix =
                this.call_type_prefix != "" &&
                this.call_type_prefix != undefined &&
                this.call_type_prefix != null &&
                this.enable_to_generate_custome_based_ticket_id != false &&
                this.enable_call_type != false
                  ? this.call_type_prefix
                  : undefined;
              inputParams.category_prefix =
                this.category_prefix != "" &&
                this.category_prefix != undefined &&
                this.category_prefix != null &&
                this.enable_to_generate_custome_based_ticket_id != false &&
                this.enable_category_prefix != false
                  ? this.category_prefix
                  : undefined;
              inputParams.product_prefix =
                this.product_prefix != "" &&
                this.product_prefix != undefined &&
                this.product_prefix != null &&
                this.enable_to_generate_custome_based_ticket_id != false &&
                this.enable_product_prefix != false
                  ? this.product_prefix
                  : undefined;
              inputParams.product_fleet_prefix =
                this.product_fleet_prefix != "" &&
                this.product_fleet_prefix != undefined &&
                this.product_fleet_prefix != null &&
                this.enable_to_generate_custome_based_ticket_id != false &&
                this.enable_product_fleet_prefix != false
                  ? this.product_fleet_prefix
                  : undefined;
              inputParams.enable_date_of_ticket_register =
                this.enable_date_of_ticket_register != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.enable_date_of_ticket_register
                  : undefined;
              inputParams.enable_ticket_sequence_reset =
                this.enable_ticket_sequence_reset != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.enable_ticket_sequence_reset
                  : undefined;
              inputParams.enable_ticket_sequence =
                this.enable_ticket_sequence != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.enable_ticket_sequence
                  : undefined;
              inputParams.ticket_sequence_reset =
                this.ticket_sequence_reset != "" &&
                this.ticket_sequence_reset != null &&
                this.ticket_sequence_reset != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.ticket_sequence_reset
                  : undefined;
              inputParams.enable_ticket_separator =
                this.enable_ticket_separator != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.enable_ticket_separator
                  : undefined;
              inputParams.ticket_separator =
                this.ticket_separator != "" &&
                this.ticket_separator != null &&
                this.ticket_separator != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.ticket_separator
                  : undefined;
              inputParams.ticket_create_sequence =
                this.ticket_create_sequence != [] &&
                this.ticket_create_sequence != null &&
                this.ticket_create_sequence != undefined &&
                this.enable_to_generate_custome_based_ticket_id != false
                  ? this.ticket_create_sequence
                  : undefined;
            }
            break;
          case "WORK_FLOW":
            this.btn_loading_workflow_settings = true;
            inputParams.enable_workflow_for_quotation =
              this.enable_workflow_for_quotation != undefined
                ? this.enable_workflow_for_quotation
                : false;
            inputParams.workflow_settings = [
              {
                workflow_enabled: this.workflow_enabled,
                module_name: "COMPONENTS",
                approver:
                  this.workflow_enabled != false ? this.approver : undefined,
                approver_ids:
                  this.workflow_enabled != false &&
                  (this.approver == "SPECIFIC_USERS" ||
                    this.approver == "REPORTING_MANAGER_AND_SPECIFIC_USER")
                    ? this.approver_ids.some((item) => typeof item === "object")
                      ? this.approver_ids.map((item) => item.user_id)
                      : this.approver_ids
                    : undefined,
              },
              {
                module_name: "PRODUCT_FLEET",
                workflow_enabled: this.enable_product_fleet_workflow,
                approver:
                  this.enable_product_fleet_workflow != false
                    ? this.product_fleet_approver
                    : undefined,
                approver_id:
                  this.enable_product_fleet_workflow != false &&
                  (this.product_fleet_approver == "SPECIFIC_USERS" ||
                    this.product_fleet_approver ==
                      "REPORTING_MANAGER_AND_SPECIFIC_USER")
                    ? this.product_fleet_approver_id
                    : undefined,
              },
              {
                module_name: "QUOTATION",
                workflow_enabled: this.enable_workflow_for_quotation,
                approver:
                  this.enable_workflow_for_quotation != false
                    ? this.quotation_approver
                    : undefined,
                approver_ids:
                  this.enable_workflow_for_quotation != false &&
                  (this.quotation_approver == "SPECIFIC_USERS" ||
                    this.quotation_approver ==
                      "REPORTING_MANAGER_AND_SPECIFIC_USER")
                    ? this.quotation_approver_ids
                    : undefined,
              },
              {
                module_name: "QUOTATION_MRF",
                workflow_enabled: this.enable_workflow_for_quotation_mrf,
                approver:
                  this.enable_workflow_for_quotation_mrf != false
                    ? this.quotation_mrf_approver
                    : undefined,
                approver_ids:
                  this.enable_workflow_for_quotation_mrf != false &&
                  (this.quotation_mrf_approver == "SPECIFIC_USERS" ||
                    this.quotation_mrf_approver ==
                      "REPORTING_MANAGER_AND_SPECIFIC_USER")
                    ? this.quotation_mrf_approver_ids
                    : undefined,
              },
              {
                module_name: "FGR",
                workflow_enabled: this.enable_workflow_for_fgr,
                approver:
                  this.enable_workflow_for_fgr != false
                    ? this.fgr_approver
                    : undefined,
                approver_ids:
                  this.enable_workflow_for_fgr != false &&
                  (this.fgr_approver == "SPECIFIC_USERS" ||
                    this.fgr_approver ==
                      "REPORTING_MANAGER_AND_SPECIFIC_USER" ||
                    this.fgr_approver ===
                      "TECHNICAL_MANAGERS_AND_SPECIFIC_USER")
                    ? this.fgr_approver_ids
                    : undefined,
                technical_manager_ids:
                  this.fgr_approver == "TECHNICAL_MANAGERS" ||
                  this.fgr_approver === "TECHNICAL_MANAGERS_AND_SPECIFIC_USER"
                    ? this.fgr_tech_manager_approver_ids
                    : undefined,
              },
              {
                module_name: "FOC",
                workflow_enabled: this.enable_workflow_for_foc,
                approver:
                  this.enable_workflow_for_foc != false
                    ? this.foc_approver
                    : undefined,
                approver_ids:
                  this.enable_workflow_for_foc != false &&
                  (this.foc_approver == "SPECIFIC_USERS" ||
                    this.foc_approver ==
                      "REPORTING_MANAGER_AND_SPECIFIC_USER" ||
                    this.foc_approver ===
                      "TECHNICAL_MANAGERS_AND_SPECIFIC_USER")
                    ? this.foc_approver_ids
                    : undefined,
                technical_manager_ids:
                  this.foc_approver == "TECHNICAL_MANAGERS" ||
                  this.foc_approver === "TECHNICAL_MANAGERS_AND_SPECIFIC_USER"
                    ? this.foc_tech_manager_approver_ids
                    : undefined,
              },
              {
                module_name: "PAYOUT",
                workflow_enabled: this.enable_payout,
                approver:
                  this.enable_payout != false
                    ? this.payout_approver
                    : undefined,
                approver_ids:
                  this.enable_payout != false &&
                  (this.payout_approver == "SPECIFIC_USERS" ||
                    this.payout_approver ==
                      "REPORTING_MANAGER_AND_SPECIFIC_USER")
                    ? this.payout_approver_ids
                    : undefined,
              },
            ];
            break;
          case "UPDATE_SUPPORT_AND_SUPPORT_TYPE":
            this.btn_update_support_and_support_type = true;
            inputParams.is_enabled_to_update_shceduled_service =
              this.is_enabled_to_update_shceduled_service;
            inputParams.support_type =
              this.is_enabled_to_update_shceduled_service == true
                ? this.support_type
                : undefined;
            inputParams.warranty_type =
              this.is_enabled_to_update_shceduled_service == true
                ? this.warranty_type
                : undefined;
            break;
          case "ORGANIZATION_LOGO":
            this.loadingOrganizationLogo = true;
            inputParams.enable_component_inventory = this.enablecomponent;
            inputParams.organization_logo_url =
              this.org_logo != undefined ? this.org_logo : undefined;
            inputParams.organization_address = this.org_address;
            inputParams.organization_contact_numbers =
              this.modifiedOrgContNumber;
            inputParams.organization_email_id = this.orgEmailId;
            break;
          case "FEEDBACK_URL":
            this.isLoading = true;
            inputParams.feedback_url_enable = this.feedback_url_enable;
            this.feedback_url != ""
              ? (inputParams.feedback_url = this.feedback_url)
              : undefined;
            break;
          case "DISTANCE_VARIATION":
            this.isLoading_distance_variation = true;
            inputParams.distance_variation = this.distance_variation;
            break;
          case "ATTENDANCE_SETTINGS":
            this.loadingATTENDANCE_SETTINGS = true;
            inputParams.automatic_log_out_time = settings.auto_logout_time;
            inputParams.weekly_offs = settings.itemsssss;
            inputParams.holiday_dates = settings.holidaydate;
            break;
          case "TICKET_SETTINGS":
            this.loadingTICKET_SETTINGS = true;
            inputParams.active_ticket_count = settings.active_ticket_count;
            inputParams.enable_ticket_creation =
              settings.enable_ticket_creation;
            inputParams.rights_of_rfs = this.duplicate_typeItems.map(
              (item) => item.value,
            );
            inputParams.enable_ticket_close = settings.enable_ticket_close;
            inputParams.default_customer_type = settings.default_customer_type;
            inputParams.reopen_ticket = settings.reopen_ticket;
            inputParams.enable_ticket_components_request =
              settings.enable_ticket_components_request;
            inputParams.is_access_control_enable =
              settings.is_access_control_enable;
            inputParams.allow_otp_proxy = settings.allow_otp_proxy;
            inputParams.auto_approval_for_own_stock_component_request =
              this.auto_approval_for_own_stock_component_request;
            inputParams.ticket_close_after_work_start =
              this.ticket_close_after_work_start;
            inputParams.end_service_at_workplace =
              this.end_service_at_workplace;
            inputParams.verify_serial_number = this.verify_serial_number;
            inputParams.is_customer_category_mandatory =
              this.is_customer_category_mandatory;
            inputParams.enable_payment_details_for_tickets =
              this.enable_payment_option;
            inputParams.enable_foc_for_ticket = this.enable_disable_foc;
            inputParams.enable_cabinet_for_tech = this.enable_disable_cabinet;
            inputParams.disable_productfleet_for_dealer =
              this.enableDisableDealerProdFleet;
            inputParams.enable_edit_warranty_details =
              this.enable_edit_warranty_details;
            inputParams.enable_edit_serial_number =
              this.enable_edit_serial_number;
            inputParams.start_service_at_workplace =
              this.start_service_at_workplace;
            inputParams.location_validation =
              this.start_service_at_workplace != undefined &&
              this.start_service_at_workplace != false
                ? this.location_validation
                : undefined;
            inputParams.end_location_validation =
              this.end_service_at_workplace != undefined &&
              this.end_service_at_workplace != false
                ? this.end_location_validation
                : undefined;
            inputParams.product_repair_or_replacement =
              settings.product_repair_or_replacement;
            inputParams.is_attachment_mandatory =
              settings.is_attachment_mandatory;
            inputParams.number_of_attachments_required =
              settings.is_attachment_mandatory != true
                ? undefined
                : settings.number_of_attachments_required;
            inputParams.sort_ticket_by = settings.sort_ticket_by;
            inputParams.enable_dealer_ticket_creation =
              settings.enable_to_rise_ticket;
            inputParams.enable_manual_territory_tagging =
              settings.enable_manual_territory_tagging;
            inputParams.scheduled_service_dates =
              settings.scheduled_service_dates;
            inputParams.ticket_history_visibility = {
              manager: this.manager,
              agent: this.agent,
              nsm: this.nsm,
              rsm: this.rsm,
              representative: this.representative,
              service_partner: this.service_partner,
              partner_agent: this.partner_agent,
              partner_representative: this.partner_representative,
              dealer_agent: this.dealer_agent,
              dealer_owner: this.dealer_owner,
              dealer_representative: this.dealer_representative,
            };
            if (settings.reopen_ticket == true) {
              inputParams.reopen_ticket_duration =
                settings.reopen_ticket_duration;
            }
            break;
          case "MASTER_CATEGORY_SETTINGS":
            this.loadingMASTER_CATEGORY_SETTINGS = true;
            inputParams.master_category_ids = settings.map(
              (item) => item.master_category_id,
            );
            break;
          case "CATEGORY_SETTINGS":
            this.loadingCATEGORY_SETTINGS = true;
            inputParams.category_ids = settings.map((item) => item.category_id);
            break;
          case "CLOSE_LOCATION_ENABLE":
            this.loading_enable_location_btn_while_close_ticket = true;
            inputParams.is_close_ticket_location_enable =
              this.is_close_ticket_location_enable;
            inputParams.is_clouser_type_enable = this.is_clouser_type_enable;
            inputParams.is_training_provided_to = this.is_training_provided_to;
            inputParams.is_otp_send_to = this.is_otp_send_to;
            break;
          case "TICKET_WORKFLOW":
            this.loading_enable_ticket_accept_btn = true;
            inputParams.enable_ticket_accept = this.enable_ticket_accept;
            inputParams.ticket_accept_time =
              this.enable_ticket_accept == true
                ? this.days_or_hours + "_" + this.ticket_accept_time
                : undefined;
            inputParams.enable_ticket_close_workflow =
              this.enable_ticket_close_workflow;
            inputParams.dealer_ticket_close_enable =
              this.enable_ticket_close_workflow == false
                ? undefined
                : this.enable_ticket_close_workflow;
            inputParams.dealer_representative_ticket_close_enable =
              this.dealer_ticket_close_enable != false
                ? this.dealer_representative_ticket_close_enable
                : undefined;
            inputParams.dealer_agent_ticket_close_enable =
              this.dealer_ticket_close_enable != false
                ? this.dealer_agent_ticket_close_enable
                : undefined;
            inputParams.service_partner_ticket_close_enable =
              this.enable_ticket_close_workflow == false
                ? false
                : this.service_partner_ticket_close_enable;
            inputParams.service_partner_representative_ticket_close_enable =
              this.enable_ticket_close_workflow == false ||
              this.service_partner_ticket_close_enable == false
                ? undefined
                : this.service_partner_representative_ticket_close_enable;
            inputParams.service_partner_agent_ticket_close_enable =
              this.enable_ticket_close_workflow == false ||
              this.service_partner_ticket_close_enable == false
                ? undefined
                : this.service_partner_agent_ticket_close_enable;
            inputParams.service_partner_higher_level_ticket_close_enable =
              this.enable_ticket_close_workflow == false ||
              this.service_partner_ticket_close_enable == false
                ? undefined
                : this.service_partner_higher_level_ticket_close_enable;
            inputParams.dealer_ticket_close_enable =
              this.enable_ticket_close_workflow == false
                ? false
                : this.dealer_ticket_close_enable;
            inputParams.organization_ticket_close_enable =
              this.enable_ticket_close_workflow == false
                ? false
                : this.organization_ticket_close_enable;
            inputParams.organization_representative_ticket_close_enable =
              this.enable_ticket_close_workflow == false ||
              this.organization_ticket_close_enable == false
                ? undefined
                : this.organization_representative_ticket_close_enable;
            inputParams.organization_RSM_ticket_close_enable =
              this.enable_ticket_close_workflow == false ||
              this.organization_ticket_close_enable == false
                ? undefined
                : this.organization_RSM_ticket_close_enable;
            inputParams.organization_NSM_ticket_close_enable =
              this.enable_ticket_close_workflow == false ||
              this.organization_ticket_close_enable == false
                ? undefined
                : this.organization_NSM_ticket_close_enable;
            inputParams.organization_coordinater_ticket_close_enable =
              this.enable_ticket_close_workflow == false ||
              this.organization_ticket_close_enable == false
                ? undefined
                : this.organization_coordinater_ticket_close_enable;
            inputParams.organization_higher_level_ticket_close_enable =
              this.enable_ticket_close_workflow == false ||
              this.organization_ticket_close_enable == false
                ? undefined
                : this.organization_higher_level_ticket_close_enable;
            inputParams.dealer_higher_level_ticket_close_enable =
              this.enable_ticket_close_workflow == false ||
              this.enable_dealer_ticket_creation == false
                ? undefined
                : this.dealer_higher_level_ticket_close_enable;
            break;
          case "ESCALATION":
            this.loading_escalation_enable = true;
            inputParams.escalation_notification_enable =
              this.escalation_notification_enable;
            inputParams.escalation_day =
              this.escalation_notification_enable == true
                ? this.escalation_day
                : undefined;
            inputParams.is_enabled_to_share_escalation_notification_to_user =
              this.enable_user_select;
            inputParams.escalation_notified_selected_users =
              this.enable_user_select === true
                ? this.escalation_user
                : undefined;
            break;
          case "TICKET_DISCARD":
            this.loading_discard_ticket_btn = true;
            inputParams.ticket_discard = this.ticket_discard;
            break;
          case "QUOTATION_DETAILS":
            this.loading_quotation_settings_btn = true;
            inputParams.enable_terms_and_conditions =
              this.enable_terms_and_conditions != undefined
                ? this.enable_terms_and_conditions
                : false;
            inputParams.terms_and_conditions =
              this.terms_and_conditions != undefined &&
              this.terms_and_conditions != null &&
              this.terms_and_conditions != "" &&
              this.enable_terms_and_conditions == true
                ? this.terms_and_conditions
                : undefined;
            inputParams.enable_discount =
              this.enable_discount != undefined ? this.enable_discount : false;
            inputParams.maximum_discount =
              this.enable_discount == true &&
              this.maximum_discount != undefined &&
              this.maximum_discount != ""
                ? parseInt(this.maximum_discount)
                : undefined;
            inputParams.enable_payment_qr_code =
              this.enable_payment_qr_code != undefined
                ? this.enable_payment_qr_code
                : false;
            inputParams.payment_qr_code_s3_url =
              this.qr_code != undefined &&
              this.qr_code != null &&
              this.qr_code != ""
                ? this.qr_code
                : undefined;
            break;
          case "PO_DETAILS":
            inputParams.enable_terms_and_conditions_for_po =
              this.enable_po_terms_and_conditions;
            inputParams.po_terms_and_conditions =
              this.po_terms_and_conditions != undefined &&
              this.po_terms_and_conditions != null &&
              this.po_terms_and_conditions != "" &&
              this.enable_po_terms_and_conditions == true
                ? this.po_terms_and_conditions
                : undefined;
            inputParams.po_narration = this.po_narration || undefined;
            break;
          case "PRODUCT_REPLACEMENT_DETAILS":
            inputParams.enable_terms_and_conditions_for_fgr = this.enableFgrTC;

            inputParams.customer_terms_and_conditions = this.enableFgrTC
              ? this.customerTermsCond
              : undefined;
            inputParams.dealer_terms_and_conditions = this.enableFgrTC
              ? this.dealerTermsCond
              : undefined;
            inputParams.product_replacement_terms_and_conditions = this
              .enableFgrTC
              ? this.fgrTermsCond
              : undefined;
            break;
          case "PAYOUT":
            inputParams.bill_period_from_date = this.formattedFromBillDate;
            inputParams.bill_period_to_date = this.formattedToBillDate;
            inputParams.gst_call_charges = parseFloat(
              parseFloat(this.gstCallCharges).toFixed(2),
            );
            inputParams.gst_spare_part = parseFloat(
              parseFloat(this.gstSparePart).toFixed(2),
            );
            break;

          case "BANK_DETAILS":
            this.loading_bank_details_btn = true;
            inputParams.bank_details = {
              account_holder: this.account_holder,
              bank_name: this.bank_name,
              account_id: this.account_id,
              ifsc: this.ifsc,
              branch: this.branch,
              bank_address:
                this.bank_address != undefined &&
                this.bank_address != "" &&
                this.bank_address != null
                  ? this.bank_address
                  : undefined,
              tax_id:
                this.tax_id != undefined &&
                this.tax_id != "" &&
                this.tax_id != null
                  ? this.tax_id
                  : undefined,
              pan_no:
                this.pan_no != undefined &&
                this.pan_no != "" &&
                this.pan_no != null
                  ? this.pan_no
                  : undefined,
              upi_id: this.upiId,
            };
        }
        this.loading = true;
        let result = await client.graphql({
          query: Update_Enterprise_Details,
          variables: {
            input: inputParams,
          },
        });

        var ResultObject = JSON.parse(result.data.Update_Enterprise_Details);
        if (ResultObject.status == "SUCCESS") {
          this.renderComp = false;
          this.$nextTick(() => {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "green",
              Top: true,
              SnackbarText: ResultObject.Status_Message,
            };
            this.renderComp = true;
          });
          this.GetAllOrganizationSettingsTypesMethod();
          this.GetCurrentUser();
        }
        this.isLoading = false;
        this.loading_bank_details_btn = false;
        this.btn_custom_ticket_id = false;
        this.loadingTICKET_SETTINGS = false;
        this.loadingOrganizationLogo = false;
        this.loadingCATEGORY_SETTINGS = false;
        this.loading_escalation_enable = false;
        this.loading_discard_ticket_btn = false;
        this.loadingATTENDANCE_SETTINGS = false;
        this.isLoading_distance_variation = false;
        this.loadingDEFAULT_CUSTOMER_TYPE = false;
        this.btn_loading_workflow_settings = false;
        this.loadingMASTER_CATEGORY_SETTINGS = false;
        this.loading_enable_ticket_accept_btn = false;
        this.btn_update_support_and_support_type = false;
        this.loading_quotation_settings_btn = false;
        this.loading_enable_location_btn_while_close_ticket = false;
      } catch (error) {
        this.loading_quotation_settings_btn = false;
        this.loading_bank_details_btn = false;
        this.btn_custom_ticket_id = false;
        this.loadingTICKET_SETTINGS = false;
        this.loadingOrganizationLogo = false;
        this.loadingCATEGORY_SETTINGS = false;
        this.loading_escalation_enable = false;
        this.loading_discard_ticket_btn = false;
        this.loadingATTENDANCE_SETTINGS = false;
        this.isLoading_distance_variation = false;
        this.loadingDEFAULT_CUSTOMER_TYPE = false;
        this.btn_loading_workflow_settings = false;
        this.loadingMASTER_CATEGORY_SETTINGS = false;
        this.loading_enable_ticket_accept_btn = false;
        this.btn_update_support_and_support_type = false;
        this.loading_enable_location_btn_while_close_ticket = false;
        this.renderComp = false;
        this.$nextTick(() => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: error.errors[0].message,
          };
          this.renderComp = true;
        });
      }
    },
    async validateMCMethod() {
      const isValid5 = await this.$refs.formMC.validate();
      if (isValid5.valid) {
        if (
          this.masterCategoryItems.filter(
            (item) =>
              item.category_id == this.masterCategorySettings.category_id,
          ).length == 0
        ) {
          let masterCategoryObject = {
            master_category_id: this.masterCategorySettings.category_id,
            master_category_name: this.GetAllMasterCategoriesList.filter(
              (item) =>
                item.category_id == this.masterCategorySettings.category_id,
            )[0].category_name,
          };
          this.masterCategoryItems.push(masterCategoryObject);
          this.$refs.formMC.reset();
        } else {
          this.renderComp = false;
          this.$nextTick(() => {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              Top: true,
              SnackbarText: "Category Name Already Exists",
            };
            this.renderComp = true;
          });
        }
      } else {
        this.renderComp = false;
        this.$nextTick(() => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Please Select Master Category",
          };
          this.renderComp = true;
        });
      }
    },

    addUserTypeDialogMethod(item, index) {
      this.user_typeItems.splice(index, 1);
      this.duplicate_typeItems.push(item);
    },
    delete_Duplicate_Method(item, index) {
      this.duplicate_typeItems.splice(index, 1);
      this.user_typeItems.push(item);
    },

    async AddServiceDetailsDialogEmit(Toggle, array) {
      this.AddServiceDetailsDialog = false;
      if (Toggle === 2) {
        try {
          const result = await client.graphql({
            query: Update_Enterprise_Details,
            variables: {
              input: {
                updater_user_id:
                  this.$store.getters.get_current_user_details.user_id,
                organization_id:
                  this.$store.getters.get_current_user_details.organization_id,
                terms_and_conditions: this.terms_and_conditions,
                setting_action: "QUOTATION_DETAILS",

                maximum_discount: this.maximum_discount,
                quotation_service_charges: array,
                enable_discount: this.enable_discount,
                enable_terms_and_conditions: this.enable_terms_and_conditions,
              },
            },
          });

          await this.GetCurrentUser();
        } catch (error) {}
      }
    },
    async CreatePincodeTypeMethod() {
      const isValid6 = await this.$refs.territoryForm.validate();
      if (isValid6.valid) {
        try {
          this.TerritoryLoading = true;
          let inputParams = {
            organization_id:
              this.$store.getters.get_current_user_details.organization_id,
            updater_user_id:
              this.$store.getters.get_current_user_details.user_id,
            pincode_territory_type: this.Territory_Name,
            estimated_time: (this.selection = "Days"
              ? this.formattedDay
              : this.Time_Values),
          };
          let result = await client.graphql({
            query: CreatePincodeType,
            variables: {
              input: inputParams,
            },
          });

          let ResultObj = JSON.parse(result.data.CreatePincodeType);
          if (ResultObj.status == "SUCCESS") {
            this.renderComp = false;
            this.$nextTick(() => {
              this.SnackBarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "primary",
                Top: true,
                SnackbarText: ResultObj.Status_Message,
              };
              this.renderComp = true;
            });
            this.Territory_Name = "";
            this.ListPincodeTypes();
          }

          this.TerritoryLoading = false;
        } catch (error) {
          this.TerritoryLoading = false;
        }
      } else {
        this.renderComp = false;
        this.$nextTick(() => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Please fill required fields",
          };
          this.renderComp = true;
        });
      }
    },

    ListPincodesHistoryDialogMethod(item) {
      this.ActionObj = item;
      this.ListPincodesHistoryDialog = true;
    },

    ListPincodesHistoryDialogEmit() {
      this.ListPincodesHistoryDialog = false;
    },

    EditTerritoriesEmit(Toggle) {
      this.ActionObj = {};
      this.EditTerritoryDialog = false;
      if (Toggle == 2) {
        this.ListPincodeTypes();
      }
    },
    edit_Territory_Method(item, action) {
      this.ActionObj = item;
      this.ActionObj.action = action;
      this.EditTerritoryDialog = true;
    },
    updateFormattedDay() {
      if (this.date) {
        const day =
          Math.floor(
            (new Date(this.date) - new Date(this.startDate)) /
              (1000 * 60 * 60 * 24),
          ) + 1;
        this.formattedDay = `${day} Days`;
      }
    },

    deleteTerritoryClassMethod(item, index) {
      this.territoryObj = item;

      this.deleteTerrClassDialog = true;
    },

    DeleteTerrClassDialogEmit(Toggle) {
      this.deleteTerrClassDialog = false;
      if (Toggle === 2) {
        this.ListPincodeTypes();
      }
    },
    webHookCardEmit() {
      this.hideWebHookViewButton = false;
    },
  },
};
</script>

<style src="@/assets/styles/organization-settings-page.css"></style>
<style scoped>
.Date_Custom .theme--light.v-date-picker-table th {
  display: none !important;
}
.Date_Custom .v-date-picker-header__weekday {
  display: none !important;
}
.Date_Custom .v-date-picker-header {
  display: none !important;
}
.v-date-picker.Date_Custom .v-date-picker-table {
  margin-top: 0 !important;
}

.v-date-picker.Date_Custom .v-date-picker-header__icon {
  display: none !important;
}
</style>
